import React, { Component } from 'react'
import ReactDOM from 'react-dom'
import { List, Slider, Tooltip, Select, Button, Checkbox, Spin, Switch, message, Row, Col, InputNumber, Drawer, Input } from 'antd';

import './optimal-ratio.less'
import { Line } from '@ant-design/plots';
import { ClickButton } from "../../components/link-button/index"
import { CaretUpOutlined, CaretDownOutlined, PieChartOutlined, DownloadOutlined, SwapOutlined, PlusCircleOutlined, CheckCircleFilled, QuestionCircleOutlined, SortAscendingOutlined, SortDescendingOutlined } from '@ant-design/icons';
import { CalcMonths, DateTimeToString, AddMonths, rateFormat1, removeTFromCode, rateFixed1, leftChar, middleChar, numFormat, makeURL, makeURL1, hexToRgb, hexToRgba, formatString } from '../utils/functionUtils'
import { getTransLocalStorage } from '../utils/storageUtils'
import { reqGetOptimalData, reqGetOptimalDataByRisk, PRICEDOWNLOAD, reqGetSimulateData, BASE, reqGetAllETFData } from "../../api/index";
import OptimalPie from './optimal-pie'
import moment from 'moment';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from 'react-intl';
import blankImage from "../../assets/image/blank.png"
import FrontierChart from '../../components/frontier-chart';

const { Option } = Select;
const railStyle = { backgroundColor: 'gray', };
const railStyle1 = { backgroundColor: '#e9e9e9', };
const trackStyle = { backgroundColor: '#0984e3', };
const handleStyle = { borderColor: '#0984e3', };
const INVESTMENT_STYLE_RISK_EPSILON = 0.01;
const ACCUMULATION_SLIDER_DISABLED_COLOR = '#d9e1ea';
const ACCUMULATION_SLIDER_ENABLED_COLOR = '#edf6ff';
const ACCUMULATION_SLIDER_DISABLED_MARK_COLOR = '#b8c2cc';
const ACCUMULATION_SLIDER_ENABLED_MARK_COLOR = '#7c8894';
const ACCUMULATION_PERIOD_UNAVAILABLE_TOAST_KEY = 'opt-accumulation-period-unavailable';
const ACCUMULATION_PERIOD_UNAVAILABLE_TOAST_MESSAGE_JA = 'この期間は現在の条件では選択できません';
const ACCUMULATION_PERIOD_UNAVAILABLE_TOAST_MESSAGE_EN = 'This period is unavailable under the current conditions.';
const spinStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: 'rgba(255, 255, 255, 0.6)',
  zIndex: 1000,
  overflow: 'auto',
};

const DEFAULT_RECEIVE_YEARS = 35; // 受取期間デフォルト（年）
const CONSTStartDate = new Date(2008, 8, 15)
const CONSTEndDate = new Date()
const ASSET_CHANGE_TOAST_KEY = 'opt-asset-change-reset';
const ASSET_CHANGE_TOAST_MESSAGE_JA = '新しい銘柄構成では利用可能な価格履歴が変わるため、リスク範囲を再設定しました。積立期間は初期値に戻しています。';
const ASSET_CHANGE_TOAST_MESSAGE_EN = 'The available price history changed with the new asset mix, so the risk range was recalculated. The accumulation period was reset to its default value.';
const normalizeConstraintOperator = (value) => {
  const normalized = String(value ?? '').trim();
  if (normalized === '≦') {
    return '<=';
  }
  if (normalized === '≧') {
    return '>=';
  }
  return normalized;
};
const JAPANESE_STOCK_PREFIXES = ['日本株-', 'JP Stocks-'];
const JAPANESE_STOCK_ISINS = [
  'JP3046600007',
  'JP3046670000',
  'JP3046630004',
  'JP3046710004',
  'JP3046700005',
  'JP3046580001',
  'JP3046610006',
  'JP3046680009',
  'JP3046690008',
  'JP3046650002',
  'JP3046560003',
  'JP3046590000',
  'JP3046620005',
  'JP3046640003',
  'JP3046660001',
  'JP3046720003',
  'JP3039100007',
];
const getApiErrorMessage = (payload, fallback = 'An unexpected error occurred') => {
  if (typeof payload === 'string' && payload.trim() !== '') {
    return payload;
  }
  if (payload && typeof payload === 'object') {
    if (typeof payload.msg === 'string' && payload.msg.trim() !== '') {
      return payload.msg;
    }
    if (typeof payload.error === 'string' && payload.error.trim() !== '') {
      return payload.error;
    }
  }
  return fallback;
};
const getLocaleFallbackMessage = (locale, jaMessage, enMessage) => (
  locale === 'en' ? enMessage : jaMessage
);

export class OptimalRatio extends Component {

  getIsValURLFromLocation = () => {
    if (this.props.id === 'val') {
      return true;
    }
    if (typeof window === 'undefined' || !window.location) {
      return false;
    }

    const normalizePath = (value) => (value || '').replace(/\/+$/, '').toLowerCase();
    const pathname = normalizePath(window.location.pathname);
    const hashPath = normalizePath((window.location.hash || '').replace(/^#/, ''));

    return pathname.includes('val') || hashPath.includes('val');
  };

  //20260108 UEDA アセットクラスの日本語英語切り替え用
  getAssetLabel = (item) => {
    if (!item) return '';
    const isEn = this.props.intl?.locale === 'en';
    const ja = item.Asset || item.asset || item.type || item.Type || '';
    const en = item.AssetEn || item.assetEn || item.typeEn || item.TypeEn || ja;
    return isEn ? en : ja;
  };


  getNameLabel = (item) => {
    const isEn = this.props.intl?.locale === 'en';
    return isEn
      ? (item.NameEn || item.nameEn || item.Name || item.name)
      : (item.Name || item.name);
  };

  getTypeLabel = (item) => {
    const isEn = this.props.intl?.locale === 'en';
    return isEn
      ? (item.TypeEn || item.typeEn || item.Type || item.type)
      : (item.Type || item.type);
  };

  state = {
    locale: getTransLocalStorage(),
    isValURL: this.getIsValURLFromLocation(),
    loading: false,
    tipMessage: '',
    ratioImage: '',
      frontierChartHotspots: {},
    correlationImage: '',
    weakCorrelationPairs: [],
    strongCorrelationPairs: [],
    isCorrelationInsightOpen: false,
    isWeakCorrelationPairsOpen: false,
    isStrongCorrelationPairsOpen: false,
    isFutureAssetSimulationDescriptionOpen: false,
    openValSettingHelpKey: '',
    isPortfolioTitleDescriptionOpen: false,
    isInvestmentStyleDescriptionOpen: false,
    isAccumulationPeriodDescriptionOpen: false,
    isRecommendedAllocationDescriptionOpen: false,
    isAllocationListDescriptionOpen: false,
    isPriceGraphDescriptionOpen: false,
    isRiskReturnDistributionDescriptionOpen: false,
    isCorrelationMapDescriptionOpen: false,
    addAssetDisabled: true,
    observValue: 1,
    defaultStartDate: new Date(2008, 8, 15),
    simulationMsg: ['', '', '', '', '', ''],
    periodMarks: {},
    specifyFlg: false,
    panelHeader: '最適割合の詳細を隠す',
    showDetailedAllocations: false,
    isJapaneseStocksMode: false,
    defaultCompositeOptimalList: [],
    periodMonths: CalcMonths(CONSTStartDate, CONSTEndDate),
    periodValue: [0, CalcMonths(CONSTStartDate, CONSTEndDate)],
    prePeriodValue: [0, CalcMonths(CONSTStartDate, CONSTEndDate)],
    startDate: CONSTStartDate,
    endDate: CONSTEndDate,
    actualEndDate: CONSTEndDate,
    volRate: 12.8,
    preVolRate: 12.8,
    riskInvestYear: 15,
    recPeriod: DEFAULT_RECEIVE_YEARS,
    payMonthly: 0,
    retRate: 12.0,
    initAmount: 300,
    monthlyAmount: 2,
    investYear: 15,
    investVolRate: 0.0,
    investRetRate: 0.0,
    investRetRateRec: 3.0,
    recPeriodDisabled: true,
    payMonthlyDisabled: false,
    investYearDisabled: false,
    investVolRateDisabled: true,
    investRetRateDisabled: true,
    investRetRateRecDisabled: true,
    valueBeforeTax: 0.0,
    valueAfterTax: 0.0,
    valueAfterTaxExNISA: 0.0,
    isCalcButtonDisabled: true,
    futureSimulationImage: null,
    searchValue: null,
    searchData: [],
    assetETFData: [],
    searchResult: [],
    initialSelectedAssetIds: [],
    assetSearchSortOrder: '',
    assetSearchSortField: 'asset',
    searchVisible: false,
    draggedFromIndex: 0,
    draggedToIndex: 0,
    sortName: 'optimalRatio',
    sortType: 'DESC',
    isDragging: false,
    optimalBtnDisabled: true,
    settingVisible1: false,
    settingVisible2: false,
    settingVisible3: false,
    displayCcy: 1,             // 1:ドル　2:円
    minVol: 10,
    maxVol: 20,
    displayMinVol: 0,
    displayMaxVol: 30,
    optimalVol: 0.0,
    FixedDeposit: 0.0,
    DefaultCcy: 'JPY',
    DefaultCcySetting: 'JPY',
    ShowObservationPeriodSetting: false,
    ShowObservationPeriod: false,
    FixedDepositSetting: 0,
    newObservValue: 1,
    assetSelectTitle: '',
    ratioSelectTitle: '',
    errorMsg: '',
    marks: {
      0: {
        label: <span >1年</span>,
      },
      5: {
        label: <span >5年</span>,
      },
      10: {
        label: <span >10年</span>,
      },
      15: {
        label: <span >15年</span>,
      },
      20: {
        label: <span >20年</span>,
      },
      30: {
        label: <span >30年以上</span>,
      }
    },
    optimalList: [
    ],
    ratioSettingList: [
    ],
    config: {
      data: [],
      xField: 'x',
      yField: 'y',
      seriesField: 'z',
      xAxis: {
        label: {
          style: {
            fontSize: 12,
          },
          formatter: (name) => name.split("-").slice(0, 2).join(""),
        },
        line: {
          style: {
            stroke: '#000000'
          },
        },
        tickLine: {
          style: {
            lineWidth: 2,
            stroke: '#000000'
          },
          length: 5,
        },
      },
      yAxis: {
        tickInterval: 1,
        value: {
          label: {
            formatter: (v) => `${v}`.replace(/\d{1,3}(?=(\d{3})+$)/g, (s) => `${s},`),
          },
        },
        min: 0.8,
        max: 3.5,
        line: {
          style: {
            stroke: '#000000',
          },
        },
        tickLine: {
          style: {
            lineWidth: 1,
            stroke: '#000000',
          },
          length: 1,
        },
        grid: {
          alternateColor: 'rgba(0,0,0,0.03)',
        },
      },
      color: [],
      legend: false,
      header: [],
      checked: [],
      tooltip: {
        customContent: (title, items) => this.customMarketTooltip(title, items),
      },
    },
    optimalPieData: {
      appendPadding: [0, 40, 0, 40],
      data: [],
      angleField: 'value',
      colorField: 'type',
      radius: 0.8,
      height: 260,
      legend: false,
      autoFit: true,
      startAngle: -Math.PI / 2,
      endAngle: Math.PI * 1.5,

      paddingAngle: 0.015,     //20251230 UEDA スライス間の隙間（ラジアン）
      // 20251230 UEDA 扇形の境界線（ここは pieStyle が安全）
      pieStyle: {
        stroke: '#ffffff',
        lineWidth: 2,
      },

      //20251230 UEDA active(ホバー強調)で形が崩れないように固定
      state: {
        active: { style: { stroke: '#ffffff', lineWidth: 2 } },
        inactive: { style: { opacity: 1 } },
      },

      interactions: [{ type: 'element-active' }],

      label: {
        type: 'spider',
        labelHeight: 36,
        layout: [],
        formatter: (data) => {
          return this.customPieLable(data);
        },
        style: {
          fontSize: 10,
          lineHeight: 13,
          textAlign: 'center',
          fill: 'black',
          fontWeight: '600',
        },
      },
      tooltip: {
        customContent: (title, items) => this.customTooltip(title, items),
      },
    },
  }

  constructor(props) {
    super(props)
    this.pie = React.createRef()
    this.targetRef = React.createRef()

  }
  translateMessage = (id) => {
    const { intl } = this.props;
    return intl.formatMessage({ id });
  };
  getLocalizedText = (jaText, enText) => {
    return this.props.intl?.locale === 'en' ? enText : jaText;
  };
  formatMessageWithFallback = (id, jaText, enText) => {
    const { intl } = this.props;
    return intl.formatMessage({
      id,
      defaultMessage: this.getLocalizedText(jaText, enText),
    });
  };
  toggleValSettingHelp = (helpKey) => {
    this.setState((prevState) => ({
      openValSettingHelpKey: prevState.openValSettingHelpKey === helpKey ? '' : helpKey,
    }));
  };
  renderValSettingHelpToggle = (label, helpKey) => {
    const isOpen = this.state.openValSettingHelpKey === helpKey;

    return (
      <button
        type='button'
        className='val-setting-help-toggle'
        aria-expanded={isOpen}
        onClick={() => this.toggleValSettingHelp(helpKey)}
      >
        <span>{label}</span>
        <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
      </button>
    );
  };
  renderValSettingHelpContent = (helpKey, content) => (
    this.state.openValSettingHelpKey === helpKey ? (
      <div className='portfolio-section-accordion-content val-setting-help-content'>
        {content}
      </div>
    ) : null
  );
  renderValSettingHelpIcon = (helpKey) => {
    const isOpen = this.state.openValSettingHelpKey === helpKey;

    return (
      <button
        type='button'
        className='val-setting-help-icon-button'
        aria-expanded={isOpen}
        onClick={() => this.toggleValSettingHelp(helpKey)}
      >
        <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
      </button>
    );
  };
  showAssetCompositionResetToast = () => {
    message.info({
      content: this.getLocalizedText(
        ASSET_CHANGE_TOAST_MESSAGE_JA,
        ASSET_CHANGE_TOAST_MESSAGE_EN
      ),
      key: ASSET_CHANGE_TOAST_KEY,
      duration: 5,
    });
  };
  showAccumulationPeriodUnavailableToast = () => {
    message.info({
      content: this.getLocalizedText(
        ACCUMULATION_PERIOD_UNAVAILABLE_TOAST_MESSAGE_JA,
        ACCUMULATION_PERIOD_UNAVAILABLE_TOAST_MESSAGE_EN
      ),
      key: ACCUMULATION_PERIOD_UNAVAILABLE_TOAST_KEY,
      duration: 3,
    });
  };
  getObservationBaselineDate = (observValue = this.state.observValue) => (
    observValue === 2
      ? new Date(1990, 0, 1)
      : new Date(2008, 8, 15)
  );
  getObservationPeriodResetState = (observValue = this.state.observValue) => {
    const baselineStartDate = this.getObservationBaselineDate(observValue);
    const periodMonths = CalcMonths(baselineStartDate, CONSTEndDate);

    return {
      defaultStartDate: baselineStartDate,
      startDate: baselineStartDate,
      endDate: CONSTEndDate,
      periodMonths,
      periodValue: [0, periodMonths],
      prePeriodValue: [0, periodMonths],
    };
  };
  resetAfterAssetCompositionChange = (additionalState = {}) => {
    this.setState({
      ...additionalState,
      ...this.getObservationPeriodResetState(),
      specifyFlg: false,
      optimalBtnDisabled: true,
      isCalcButtonDisabled: false,
    }, () => {
      this.reoptimizeAfterAssetCompositionChange();
    });
  };
  reoptimizeAfterAssetCompositionChange = () => {
    const { sortName, sortType } = this.state;
    this.sortData(sortName, sortType);
    this.showAssetCompositionResetToast();
    this.getOptimalData(false, false);
  };
  cloneOptimalList = (optimalList = []) => optimalList.map((item) => ({ ...item }));
  normalizeRiskFreeFlag = (item) => Boolean(item?.isRiskFreeAsset ?? item?.is_risk_free);
  normalizeAssetETFItem = (item) => ({
    ...item,
    isRiskFreeAsset: this.normalizeRiskFreeFlag(item),
  });
  getCanonicalInstrumentId = (item) => {
    if (!item) {
      return '';
    }
    const isin = String(item.isin ?? item.ISIN ?? '').trim();
    if (isin !== '') {
      return isin;
    }
    return removeTFromCode(item.code ?? item.Code ?? item.key ?? '');
  };
  getCanonicalInstrumentIdList = (items = []) => (
    items
      .map((item) => this.getCanonicalInstrumentId(item))
      .filter((id) => id !== '')
  );
  buildCanonicalInstrumentIdSet = (items = []) => (
    new Set(this.getCanonicalInstrumentIdList(items))
  );
  isSameInstrument = (left, right) => {
    const leftId = this.getCanonicalInstrumentId(left);
    const rightId = this.getCanonicalInstrumentId(right);
    return leftId !== '' && leftId === rightId;
  };
  getRequestedStockIdForAsset = (item) => {
    const isin = String(item?.ISIN ?? item?.isin ?? '').trim();
    if (isin !== '') {
      return isin;
    }
    return removeTFromCode(item?.Code ?? item?.code ?? '');
  };
  normalizeLegacyInstrumentKey = (value) => {
    const normalized = removeTFromCode(value || '').trim().toUpperCase();
    if (normalized === '') {
      return '';
    }
    const trimmedLeadingZeros = normalized.replace(/^0+/, '');
    return trimmedLeadingZeros === '' ? '0' : trimmedLeadingZeros;
  };
  findAssetByLegacyCode = (code, assetETFData = this.state.assetETFData) => {
    const normalizedCode = this.normalizeLegacyInstrumentKey(code);
    if (normalizedCode === '') {
      return null;
    }
    return assetETFData.find(
      (item) => this.normalizeLegacyInstrumentKey(item?.Code) === normalizedCode
    ) || null;
  };
  resolveRequestedBenchmarkId = (item, assetETFData = this.state.assetETFData) => {
    const rawBenchmark = String(item?.Benchmark ?? item?.benchmark ?? '').trim();
    if (rawBenchmark === '') {
      return '';
    }
    const matchedBenchmarkAsset = this.findAssetByLegacyCode(rawBenchmark, assetETFData);
    if (matchedBenchmarkAsset) {
      return this.getRequestedStockIdForAsset(matchedBenchmarkAsset);
    }
    return '';
  };
  isRiskFreeAssetItem = (item) => this.normalizeRiskFreeFlag(item);
  getEditableOptimalList = (optimalList = []) => (
    optimalList.filter((item) => !this.isRiskFreeAssetItem(item))
  );
  getEditableOptimalCodes = (optimalList = []) => (
    this.getEditableOptimalList(optimalList).map((item) => item.code)
  );
  buildOptimalPayloadList = (optimalList = []) => (
    this.getEditableOptimalList(optimalList).map((item) => ({ ...item }))
  );
  buildBackendOptimalPayloadList = (optimalList = []) => (
    this.cloneOptimalList(optimalList).map((item) => ({ ...item, selected: false }))
  );
  buildOptimizationPayloadList = (optimalList = []) => (
    this.getEditableOptimalList(optimalList).map((item) => ({ ...item, selected: false }))
  );
  isJapaneseStockDisplayAsset = (item) => {
    const assetLabel = this.getAssetLabel(item);
    return (
      assetLabel === '日本株'
      || assetLabel === 'JP Stocks'
      || JAPANESE_STOCK_PREFIXES.some((prefix) => assetLabel.startsWith(prefix))
    );
  };
  shouldHideNonJapaneseStockInJapaneseStocksMode = (
    item,
    isJapaneseStocksMode = this.state.isJapaneseStocksMode
  ) => isJapaneseStocksMode && !this.isJapaneseStockDisplayAsset(item);
  isPositiveAllocation = (item) => Number(item?.optimalRatio) > 0;
  shouldDisplayAllocationRow = (
    item,
    showDetailedAllocations,
    isJapaneseStocksMode = this.state.isJapaneseStocksMode
  ) => {
    if (this.shouldHideNonJapaneseStockInJapaneseStocksMode(item, isJapaneseStocksMode)) {
      return false;
    }
    return showDetailedAllocations || this.isPositiveAllocation(item);
  };
  getVisibleOptimalList = (
    optimalList,
    showDetailedAllocations,
    isJapaneseStocksMode = this.state.isJapaneseStocksMode
  ) => {
    return optimalList.reduce((acc, item, originalIndex) => {
      if (this.shouldDisplayAllocationRow(item, showDetailedAllocations, isJapaneseStocksMode)) {
        acc.push({ ...item, originalIndex });
      }
      return acc;
    }, []);
  };
  isJapaneseStockAsset = (item) => {
    if (!item) {
      return false;
    }
    const assetLabel = this.getAssetLabel(item);
    const code = this.getCanonicalInstrumentId(item);
    return (
      JAPANESE_STOCK_ISINS.includes(code)
      || JAPANESE_STOCK_PREFIXES.some((prefix) => assetLabel.startsWith(prefix))
    );
  };
  shouldOmitJapaneseStockPrefix = (optimalList = []) => {
    const items = optimalList.filter((item) => item && !this.isRiskFreeAssetItem(item));
    return items.length > 0 && items.every((item) => this.isJapaneseStockAsset(item));
  };
  stripJapaneseStockPrefix = (label = '') => {
    const prefix = JAPANESE_STOCK_PREFIXES.find((value) => label.startsWith(value));
    return prefix ? label.slice(prefix.length) : label;
  };
  getDisplayAssetLabel = (item, optimalList = this.state.optimalList) => {
    const assetLabel = this.getAssetLabel(item);
    if (!this.shouldOmitJapaneseStockPrefix(optimalList)) {
      return assetLabel;
    }
    return this.stripJapaneseStockPrefix(assetLabel);
  };
  shortenAssetLabel = (label, maxLength = 14) => {
    if (!label) {
      return '';
    }
    return label.length > maxLength ? `${label.slice(0, maxLength - 1)}…` : label;
  };
  getPieLabelText = (data) => {
    return data.displayLabel || data.assetLabel || data.type.replace(/-\d+$/, '');
  };
  getAssetClassColor = (assetLabel) => {
    const matched = (this.state.assetETFData || []).find(
      (asset) => this.getAssetLabel(asset) === assetLabel
    );
    return matched?.Color || matched?.color || '';
  };
  getItemColor = (item) => {
    if (item?.displayType && item.displayType !== this.getAssetLabel(item)) {
      return item?.color || item?.Color || '';
    }
    if (this.isJapaneseStockAsset(item)) {
      return this.getAssetClassColor('日本株') || item?.color || item?.Color || '';
    }
    return item?.color || item?.Color || '';
  };
  getMarketSeriesColor = (header, optimalList) => {
    const code = header.substring(
      header.lastIndexOf('(') + 1,
      header.lastIndexOf(')')
    );
    const item = (optimalList || []).find(
      value => removeTFromCode(value.code) === code
    ) || (this.state.assetETFData || []).find(
      value => removeTFromCode(value.code || value.Code || '') === code
    );

    const color = this.getItemColor(item)
      || this.getAssetClassColor(item ? this.getAssetLabel(item) : header.split('(')[0]);

    return /^#[0-9a-fA-F]{6}$/.test(color) ? color : '#808080';
  };

  normalizeOptimalListItem = (item) => ({
    ...item,
    color: this.getItemColor(item),
    isRiskFreeAsset: this.normalizeRiskFreeFlag(item),
  });
  normalizeCorrelationPairs = (pairs = []) => (
    (pairs || []).map((pair, index) => ({
      rank: Number.isFinite(Number(pair?.rank)) ? Number(pair.rank) : index + 1,
      pair: pair?.pair || '',
      correlation: Number(pair?.correlation),
      comment: pair?.comment || '',
      leftCode: pair?.leftCode || '',
      rightCode: pair?.rightCode || '',
    }))
  );
  buildPieData = (optimalList) => {
    const shouldOmitPrefix = this.shouldOmitJapaneseStockPrefix(optimalList);
    const nonZeroItems = optimalList
      .filter((item) => Number(item.optimalRatio) !== 0)
      .sort((a, b) => Number(b.optimalRatio || 0) - Number(a.optimalRatio || 0));
    return {
      data: nonZeroItems.map((item, index) => {
        const assetLabel = item.displayType || this.getAssetLabel(item);
        const displayLabel = shouldOmitPrefix ? this.stripJapaneseStockPrefix(assetLabel) : assetLabel;
        return {
          type: `${assetLabel}-${index}`,
          assetLabel,
          displayLabel,
          fullName: item.fullName || this.getNameLabel(item),
          color: this.getItemColor(item),
          value: item.optimalRatio,
          code: item.code,
          inceptionDate: item.inceptionDate,
        };
      }),
      colors: nonZeroItems.map((item) => this.getItemColor(item)),
    };
  };
  updateOptimalPieData = (optimalList) => {
    const { data, colors } = this.buildPieData(optimalList);
    this.setState((prevState) => ({
      optimalPieData: {
        ...prevState.optimalPieData,
        data,
        color: colors,
        theme: 'custom-theme',
      },
    }), () => {
      if (this.pie) {
        this.pie.updatePieData(this.state.optimalPieData);
      }
    });
  };
  formatPercentValue = (value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return 'ー';
    }
    return `${rateFormat1(numericValue)}%`;
  };
  formatYearsValue = (years) => {
    const yearsLabel = this.formatMessageWithFallback('Years', '年', 'years');
    return this.props.intl?.locale === 'en'
      ? `${years} ${yearsLabel}`
      : `${years}${yearsLabel}`;
  };
  getRiskSliderSummaryText = (riskValue, yearsValue = this.state.riskInvestYear) => {
    const riskLabel = this.formatMessageWithFallback('ExpectedRisk', '想定リスク', 'Expected risk');
    return (
      <span style={{ whiteSpace: 'nowrap', color: 'black' }}>
        <span>{this.formatYearsValue(yearsValue)}</span>
        <span style={{ fontSize: '13px', color: '#a6a6a6' }}>（{riskLabel}）</span>
        <span> {this.formatPercentValue(riskValue)}</span>
      </span>
    );
  };
  formatCorrelationValue = (value) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return 'ー';
    }
    return numericValue.toFixed(2);
  };
  getCorrelationPairNoticeText = () => (
    this.getLocalizedText(
      '留意事項：リスクが5%以下の銘柄は値動きが小さく、組み合わせによる分散効果を評価しにくいため、相関ペアの抽出対象から除外しています。',
      'Note: Assets with risk at or below 5% are excluded from correlation-pair extraction because their price movements are small, making diversification effects harder to evaluate.'
    )
  );
  toggleCorrelationPairSection = (stateKey) => {
    this.setState((prevState) => ({
      [stateKey]: !prevState[stateKey],
    }));
  };
  renderCorrelationPairSection = ({ title, stateKey, pairs, emptyMessage, testId }) => {
    const isOpen = Boolean(this.state[stateKey]);
    return (
      <div className='correlation-pair-section' data-testid={`${testId}-section`}>
        <button
          type='button'
          className='portfolio-section-accordion-toggle correlation-pair-toggle'
          onClick={() => this.toggleCorrelationPairSection(stateKey)}
          aria-expanded={isOpen}
          data-testid={`${testId}-toggle`}
        >
          <span>{title}</span>
          <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
        </button>
        {isOpen && (
          <div className='portfolio-section-accordion-content correlation-pair-content' data-testid={`${testId}-content`}>
            {pairs.length === 0 ? (
              <div className='correlation-pair-empty'>{emptyMessage}</div>
            ) : (
              <div className='correlation-pair-table-wrapper'>
                <table className='correlation-pair-table'>
                  <thead>
                    <tr>
                      <th>{this.getLocalizedText('順位', 'Rank')}</th>
                      <th>{this.getLocalizedText('資産ペア', 'Asset pair')}</th>
                      <th>{this.getLocalizedText('相関係数', 'Correlation')}</th>
                      <th>{this.getLocalizedText('コメント', 'Comment')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {pairs.map((pair) => (
                      <tr key={`${testId}-${pair.rank}-${pair.pair}`}>
                        <td>{pair.rank}</td>
                        <td>{pair.pair}</td>
                        <td>{this.formatCorrelationValue(pair.correlation)}</td>
                        <td>{pair.comment}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            <div className='correlation-pair-note' data-testid={`${testId}-note`}>
              {this.getCorrelationPairNoticeText()}
            </div>
          </div>
        )}
      </div>
    );
  };
  renderCorrelationInsightSection = ({ title, testId }) => {
    const isOpen = Boolean(this.state.isCorrelationInsightOpen);
    return (
      <div className='correlation-pair-section correlation-insight-section' data-testid={`${testId}-section`}>
        <button
          type='button'
          className='portfolio-section-accordion-toggle correlation-pair-toggle'
          onClick={() => this.toggleCorrelationPairSection('isCorrelationInsightOpen')}
          aria-expanded={isOpen}
          data-testid={`${testId}-toggle`}
        >
          <span>{title}</span>
          <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
        </button>
        {isOpen && (
          <div className='portfolio-section-accordion-content correlation-pair-content' data-testid={`${testId}-content`}>
            <div className='correlation-insight-card'>
              <p>
                {this.getLocalizedText(
                  '相関係数は -1 から +1 の範囲で、+1 に近いほど同じ方向に動き、-1 に近いほど逆方向に動きます。0 に近い資産同士は値動きの連動性が低く、組み合わせることで分散効果が期待できます。',
                  'Correlation ranges from -1 to +1. Values closer to +1 move in the same direction, while values closer to -1 move in opposite directions. Assets near 0 have low co-movement and can improve diversification when combined.'
                )}
              </p>
              <p>
                {this.getLocalizedText(
                  '「相関が弱いペア」は、ポートフォリオ全体のリスクを低減させる組み合わせを検討する際の参考になります。「相関が強いペア」は、似た値動きをするため、同じような値動きをする資産に偏っていないかを確認する際に役立ちます。',
                  '"Weak-correlation pairs" can help when considering combinations that may reduce overall portfolio risk. "Strong-correlation pairs" are useful for checking whether your assets are tilted toward investments that tend to move in similar ways.'
                )}
              </p>
            </div>
          </div>
        )}
      </div>
    );
  };
  getRiskSliderTooltipText = (riskValue) => {
    const { displayMinVol, displayMaxVol } = this.state;
    const accumulationPeriodLabel = this.formatMessageWithFallback('AccumulationPeriod', '積立期間', 'Accumulation period');
    const riskLabel = this.formatMessageWithFallback('ExpectedRisk', '想定リスク', 'Expected risk');
    const yearsValue = this.clacRiskInvestYear(riskValue, displayMinVol, displayMaxVol);
    const separator = this.props.intl?.locale === 'en' ? ': ' : '：';
    return `${accumulationPeriodLabel}${separator}${this.formatYearsValue(yearsValue)} / ${riskLabel}${separator}${this.formatPercentValue(riskValue)}`;
  };
  getRiskSliderMinValue = () => 0;
  getSliderNumericValue = (value) => {
    if (Array.isArray(value)) {
      return Number(value[0]);
    }
    return Number(value);
  };
  clampRiskSliderValue = (value, maxVol = this.state.maxVol, minVol = this.getRiskSliderMinValue()) => {
    const numericValue = Number(value);
    if (!Number.isFinite(numericValue)) {
      return Number.isFinite(Number(minVol)) ? Number(minVol) : this.getRiskSliderMinValue();
    }
    const normalizedMinVol = Number.isFinite(Number(minVol))
      ? Number(minVol)
      : this.getRiskSliderMinValue();
    if (!Number.isFinite(Number(maxVol))) {
      return Math.max(normalizedMinVol, numericValue);
    }
    return Math.min(Math.max(normalizedMinVol, numericValue), Number(maxVol));
  };
  shouldSkipOptimizeByRisk = (riskValue = this.state.volRate, minVol = this.state.minVol) => {
    const normalizedRiskValue = Number(riskValue);
    const normalizedMinVol = Number(minVol);
    return Number.isFinite(normalizedRiskValue)
      && Number.isFinite(normalizedMinVol)
      && normalizedRiskValue <= normalizedMinVol;
  };
  buildRiskFreeOnlyOptimalList = (optimalList = this.state.optimalList, fixedDeposit = this.state.FixedDeposit) => (
    optimalList.map((item) => {
      const normalizedItem = this.normalizeOptimalListItem(item);
      if (this.isRiskFreeAssetItem(normalizedItem)) {
        return {
          ...normalizedItem,
          optimalRatio: 100.0,
          returnRatio: fixedDeposit,
          riskRatio: 0.0,
          selected: false,
        };
      }
      return {
        ...normalizedItem,
        optimalRatio: 0.0,
        selected: false,
      };
    })
  );
  applyRiskFreeOnlyAllocation = ({
    selectedRiskValue,
    retRate,
    investYear,
    investVolRate,
    investRetRate,
    isValURL,
    investRetRateRec,
    optimalList = this.state.optimalList,
    fixedDeposit = this.state.FixedDeposit,
    minVol = this.state.minVol,
    maxVol = this.state.maxVol,
    displayMinVol = this.state.displayMinVol,
    displayMaxVol = this.state.displayMaxVol,
    additionalState = {},
  }) => {
    const riskFreeOnlyList = this.buildRiskFreeOnlyOptimalList(optimalList, fixedDeposit);
    const sortedRiskFreeOnlyList = this.getSortedOptimalList(
      riskFreeOnlyList,
      this.state.sortName,
      this.state.sortType
    );
    this.setState({
      ...additionalState,
      loading: false,
      optimalList: sortedRiskFreeOnlyList,
      showDetailedAllocations: false,
      correlationImage: '',
      weakCorrelationPairs: [],
      strongCorrelationPairs: [],
      FixedDeposit: fixedDeposit,
      minVol,
      maxVol,
      displayMinVol,
      displayMaxVol,
      retRate,
      volRate: selectedRiskValue,
      preVolRate: selectedRiskValue,
      investYear,
      investVolRate,
      investRetRate,
      riskInvestYear: this.clacRiskInvestYear(selectedRiskValue, displayMinVol, displayMaxVol),
    });
    this.updateOptimalPieData(riskFreeOnlyList);
    if (isValURL) {
      this.getSimulateData(
        investVolRate,
        investRetRate,
        investRetRateRec,
        investYear,
        this.state.initAmount,
        this.state.monthlyAmount,
        this.state.recPeriod,
        false
      );
    }
  };
  getPortfolioProposalTitle = () => {
    return this.translateMessage('PortfolioTitle');
  };
  getPortfolioTitleAccordionLabel = () => {
    return this.getLocalizedText('最適な資産配分の説明', 'About the optimized allocation');
  };
  getInvestmentStyleAccordionLabel = () => {
    return this.getLocalizedText('投資スタイル', 'Investment Style');
  };
  getAccumulationPeriodAccordionLabel = () => {
    return this.formatMessageWithFallback('AccumulationPeriod', '積立期間', 'Accumulation period');
  };
  getRecommendedAllocationTitle = () => {
    return this.getLocalizedText('おすすめ配分', 'Recommended allocation');
  };
  getDetailToggleLabel = (showDetailedAllocations) => {
    return this.getLocalizedText(
      showDetailedAllocations ? '詳細な配分を閉じる' : '詳細な配分を表示',
      showDetailedAllocations ? 'Hide detailed allocation' : 'Show detailed allocation'
    );
  };
  getJapaneseStocksToggleLabel = (isJapaneseStocksMode) => {
    return this.getLocalizedText(
      isJapaneseStocksMode ? '複合資産' : '日本株のみ',
      isJapaneseStocksMode ? 'Multi-Asset' : 'JP Stocks'
    );
  };
  getInvestmentStyleThresholds = () => {
    return [
      {
        key: 'stability_focus',
        maxRisk: 10,
        targetRisk: 5,
        labelJa: '安定重視',
        labelEn: 'Stability Focus',
        rangeJa: '10%以下',
        rangeEn: '10% or less',
      },
      {
        key: 'moderately_conservative',
        maxRisk: 15,
        targetRisk: 10,
        labelJa: 'やや安定重視',
        labelEn: 'Moderately Conservative',
        rangeJa: '10%超〜15%以下',
        rangeEn: 'over 10% up to 15%',
      },
      {
        key: 'balanced',
        maxRisk: 20,
        targetRisk: 15,
        labelJa: 'バランス重視',
        labelEn: 'Balanced',
        rangeJa: '15%超〜20%以下',
        rangeEn: 'over 15% up to 20%',
      },
      {
        key: 'growth_focus',
        maxRisk: 25,
        targetRisk: 20,
        labelJa: '成長重視',
        labelEn: 'Growth Focus',
        rangeJa: '20%超〜25%以下',
        rangeEn: 'over 20% up to 25%',
      },
      {
        key: 'aggressive_growth',
        maxRisk: Infinity,
        targetRisk: 25,
        labelJa: '積極成長',
        labelEn: 'Aggressive Growth',
        rangeJa: '25%超',
        rangeEn: 'over 25%',
      },
    ];
  };
  getSelectedInvestmentStyle = (riskValue) => {
    const numericRiskValue = Number(riskValue);
    if (!Number.isFinite(numericRiskValue)) {
      return null;
    }
    return this.getInvestmentStyleThresholds().find(
      ({ maxRisk }) => numericRiskValue <= maxRisk
    ) || this.getInvestmentStyleThresholds()[this.getInvestmentStyleThresholds().length - 1];
  };
  getInvestmentStyleLabel = (riskValue) => {
    const matchedStyle = this.getSelectedInvestmentStyle(riskValue);
    if (!matchedStyle) {
      return this.getLocalizedText('ー', '-');
    }
    return this.getLocalizedText(matchedStyle.labelJa, matchedStyle.labelEn);
  };
  getInvestmentStyleRiskWindow = (styleKey) => {
    const styles = this.getInvestmentStyleThresholds();
    const styleIndex = styles.findIndex((style) => style.key === styleKey);
    const matchedStyle = styleIndex >= 0 ? styles[styleIndex] : null;
    if (!matchedStyle) {
      return null;
    }

    const previousStyle = styleIndex > 0 ? styles[styleIndex - 1] : null;
    return {
      minRisk: previousStyle ? previousStyle.maxRisk + INVESTMENT_STYLE_RISK_EPSILON : this.getRiskSliderMinValue(),
      maxRisk: matchedStyle.maxRisk,
    };
  };
  getInvestmentStyleRiskBounds = (
    minVol = this.state.displayMinVol,
    maxVol = this.state.displayMaxVol
  ) => {
    const numericMinVol = Number(minVol);
    const numericMaxVol = Number(maxVol);
    return {
      minRisk: Number.isFinite(numericMinVol) ? numericMinVol : null,
      maxRisk: Number.isFinite(numericMaxVol) ? numericMaxVol : null,
    };
  };
  isInvestmentStyleEnabled = (
    styleKey,
    minVol = this.state.displayMinVol,
    maxVol = this.state.displayMaxVol
  ) => {
    const matchedStyle = this.getInvestmentStyleThresholds().find(
      (style) => style.key === styleKey
    );
    if (!matchedStyle) {
      return false;
    }

    const { minRisk, maxRisk } = this.getInvestmentStyleRiskBounds(minVol, maxVol);
    if (!Number.isFinite(minRisk) || !Number.isFinite(maxRisk)) {
      return true;
    }

    return minRisk <= matchedStyle.targetRisk && matchedStyle.targetRisk <= maxRisk;
  };
  getAccumulationSliderRiskBounds = (
    minVol = this.state.displayMinVol,
    maxVol = this.state.displayMaxVol
  ) => {
    const overallBounds = this.getInvestmentStyleRiskBounds(minVol, maxVol);
    return {
      minRisk: Number.isFinite(overallBounds.minRisk)
        ? overallBounds.minRisk
        : this.getRiskSliderMinValue(),
      maxRisk: Number.isFinite(overallBounds.maxRisk)
        ? overallBounds.maxRisk
        : this.getRiskSliderMinValue(),
    };
  };
  getAccumulationPeriodMarkText = (yearsValue) => {
    if (yearsValue >= 30) {
      return this.getLocalizedText('30年以上', '30+ years');
    }
    return this.formatYearsValue(yearsValue);
  };
  isRiskValueWithinBounds = (riskValue, bounds) => {
    const numericRiskValue = Number(riskValue);
    if (!Number.isFinite(numericRiskValue) || !bounds) {
      return false;
    }
    return numericRiskValue >= bounds.minRisk && numericRiskValue <= bounds.maxRisk;
  };
  getSelectableRiskValue = (
    riskValue,
    minVol = this.state.displayMinVol,
    maxVol = this.state.displayMaxVol
  ) => {
    const bounds = this.getAccumulationSliderRiskBounds(minVol, maxVol);
    return this.clampRiskSliderValue(riskValue, bounds.maxRisk, bounds.minRisk);
  };
  getAccumulationSliderMarks = (
    bounds,
    marks = this.state.marks
  ) => {
    const normalizedBounds = bounds || this.getAccumulationSliderRiskBounds();
    return Object.fromEntries(
      Object.entries(marks).map(([value, mark]) => {
        const isEnabled = this.isRiskValueWithinBounds(Number(value), normalizedBounds);
        return [
          value,
          {
            ...mark,
            style: {
              ...(mark?.style || {}),
              color: isEnabled
                ? ACCUMULATION_SLIDER_ENABLED_MARK_COLOR
                : ACCUMULATION_SLIDER_DISABLED_MARK_COLOR,
            },
          },
        ];
      })
    );
  };


getAccumulationSliderRailStyle = (
  bounds,
  sliderMax = this.state.displayMaxVol
) => {
  const normalizedMax = Number(sliderMax);
  const normalizedBounds = bounds || this.getAccumulationSliderRiskBounds();

  if (!Number.isFinite(normalizedMax) || normalizedMax <= this.getRiskSliderMinValue()) {
    return railStyle;
  }

  const hasRiskFreeAsset = (this.state.optimalList || []).some(
    (item) => item.isRiskFreeAsset
  );

  const effectiveMinRisk = hasRiskFreeAsset
    ? this.getRiskSliderMinValue()
    : normalizedBounds.minRisk;

  const minPercent = Math.max(0, Math.min(100, (effectiveMinRisk / normalizedMax) * 100));
  const maxPercent = Math.max(0, Math.min(100, (normalizedBounds.maxRisk / normalizedMax) * 100));

  return {
    ...railStyle,
    background: `linear-gradient(to right, ${ACCUMULATION_SLIDER_DISABLED_COLOR} 0%, ${ACCUMULATION_SLIDER_DISABLED_COLOR} ${minPercent}%, ${ACCUMULATION_SLIDER_ENABLED_COLOR} ${minPercent}%, ${ACCUMULATION_SLIDER_ENABLED_COLOR} ${maxPercent}%, ${ACCUMULATION_SLIDER_DISABLED_COLOR} ${maxPercent}%, ${ACCUMULATION_SLIDER_DISABLED_COLOR} 100%)`,
  };
};

getAccumulationSliderRailCssVars = (
  bounds,
  sliderMax = this.state.displayMaxVol
) => {
  const normalizedMax = Number(sliderMax);
  const normalizedBounds = bounds || this.getAccumulationSliderRiskBounds();

  if (!Number.isFinite(normalizedMax) || normalizedMax <= this.getRiskSliderMinValue()) {
    return {
      '--accumulation-slider-min-percent': '0%',
      '--accumulation-slider-max-percent': '0%',
    };
  }

  const hasRiskFreeAsset = (this.state.optimalList || []).some(
    (item) => item.isRiskFreeAsset
  );

  const effectiveMinRisk = hasRiskFreeAsset
    ? this.getRiskSliderMinValue()
    : normalizedBounds.minRisk;

  const minPercent = Math.max(0, Math.min(100, (effectiveMinRisk / normalizedMax) * 100));
  const maxPercent = Math.max(0, Math.min(100, (normalizedBounds.maxRisk / normalizedMax) * 100));

  return {
    '--accumulation-slider-min-percent': `${minPercent}%`,
    '--accumulation-slider-max-percent': `${maxPercent}%`,
  };
};

  getInvestmentStyleTargetRisk = (styleKey, minVol = this.state.displayMinVol, maxVol = this.state.displayMaxVol) => {
    const styles = this.getInvestmentStyleThresholds();
    const styleIndex = styles.findIndex((style) => style.key === styleKey);
    const matchedStyle = styleIndex >= 0 ? styles[styleIndex] : null;
    if (!matchedStyle) {
      return this.clampRiskSliderValue(this.state.volRate, maxVol);
    }

    const numericMinVol = Number(minVol);
    const numericMaxVol = Number(maxVol);
    const fallbackMinVol = Number.isFinite(numericMinVol) ? numericMinVol : matchedStyle.targetRisk;
    const fallbackMaxVol = Number.isFinite(numericMaxVol) ? numericMaxVol : matchedStyle.targetRisk;
    let desiredRisk = matchedStyle.targetRisk;

    if (matchedStyle.key === 'stability_focus' && fallbackMinVol > desiredRisk) {
      desiredRisk = fallbackMinVol;
    }

    const previousStyle = styleIndex > 0 ? styles[styleIndex - 1] : null;
    if (previousStyle && desiredRisk <= previousStyle.maxRisk) {
      desiredRisk = previousStyle.maxRisk + INVESTMENT_STYLE_RISK_EPSILON;
    }

    if (matchedStyle.key === 'aggressive_growth' && fallbackMaxVol < desiredRisk) {
      desiredRisk = fallbackMaxVol;
    }

    return this.clampRiskSliderValue(desiredRisk, fallbackMaxVol);
  };
  handleInvestmentStyleSelect = (styleKey) => {
    const { displayMinVol, displayMaxVol } = this.state;
    if (!this.isInvestmentStyleEnabled(styleKey, displayMinVol, displayMaxVol)) {
      return;
    }
    const nextRiskValue = this.getInvestmentStyleTargetRisk(styleKey, displayMinVol, displayMaxVol);
    const nextRiskInvestYear = this.clacRiskInvestYear(nextRiskValue, displayMinVol, displayMaxVol);

    this.setState({
      volRate: nextRiskValue,
      riskInvestYear: nextRiskInvestYear,
      isCalcButtonDisabled: false,
      specifyFlg: true,
      optimalBtnDisabled: false,
    }, () => {
      this.onAfterChangeRisk(nextRiskValue);
    });
  };
  getInvestmentStyleTooltipContent = () => {
    const title = this.getLocalizedText('投資スタイルとは？', 'What is Investment Style?');
    const body = this.getLocalizedText(
      '想定リスクの大きさに応じて、ポートフォリオの運用傾向を5段階で表示しています。リスクが低いほど安定性を重視し、リスクが高いほど成長性を重視したスタイルになります。',
      'The investment style indicates the portfolio’s management approach based on the expected risk level. Lower risk portfolios focus more on stability, while higher risk portfolios emphasize growth potential.'
    );
    const classificationTitle = this.getLocalizedText('判定基準', 'Classification');

    return (
      <div className='investment-style-tooltip'>
        <div className='investment-style-tooltip-title'>{title}</div>
        <div className='investment-style-tooltip-body'>{body}</div>
        <div className='investment-style-tooltip-section'>{classificationTitle}</div>
        <ul className='investment-style-tooltip-list'>
          {this.getInvestmentStyleThresholds().map((style) => (
            <li key={style.labelEn}>
              <span className='investment-style-tooltip-list-label'>
                {this.getLocalizedText(style.labelJa, style.labelEn)}
              </span>
              <span>{this.getLocalizedText(style.rangeJa, style.rangeEn)}</span>
            </li>
          ))}
        </ul>
      </div>
    );
  };
  customPieLable = (data) => {
    const label = this.getPieLabelText(data);
    return `${label}\n${rateFormat1(data.percent * 100)}%`;
  }
  customMarketTooltip = (title, items) => {
    const { config } = this.state;
    if (items.length === 0) return (<div></div>)
    else {
      let newItems = [...items].sort((a, b) => b.value - a.value);
      newItems = newItems.filter(v => config.checked.includes(v.name))
      return (
        <div style={{ background: 'rgba(255, 255, 255, 0.8)' }} >
          <div style={{ display: 'flex', fontSize: 16, height: '35px', fontWeight: 'bold', width: '200px', paddingTop: '10px' }}>
            <div style={{ flex: 8, textAlign: 'left' }}>{this.translateMessage('Price')}</div>
            <div style={{ flex: 8, textAlign: 'right' }}>{newItems[0]?.title || ''}</div>
          </div>
          {newItems.map((item, index) => (
            <div
              key={`${item.name || 'market-item'}-${item.title || item.code || index}`}
              style={{ display: 'flex', fontSize: 14, height: '24px', width: '200px' }}
            >
              <span style={{ flex: 1, color: this.getItemColor(item) }}>■</span>
              <span style={{ flex: 10, color: '#a6a6a6', whiteSpace: 'nowrap', textAlign: 'left' }}><span style={{ color: 'black' }}>{leftChar(item.name)}</span>{middleChar(item.name)}</span>
              <span style={{ flex: 5, marginLeft: '10px', fontWeight: 'bold', whiteSpace: 'nowrap', textAlign: 'right' }}> {rateFixed1(item.value, 5)}</span>
            </div>
          ))}
        </div>
      );
    }

  };

  customTooltip = (title, items) => {
    return (
      <div style={{ padding: 5, fontSize: 14, fontWeight: 'bold', background: 'rgba(255, 255, 255, 0.8)' }}>
        {items.map((item, index) =>
        (
          <div
            key={`${item.data.code || item.data.assetLabel || item.data.fullName || 'tooltip-item'}-${item.data.inceptionDate || index}`}
            style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}
          >
            {/* 1行目 */}
            <div style={{
              display: 'flex',
              alignItems: 'flex-start',
              //height:'25px',
              lineHeight: 1.4,
              marginBottom: 4,    // ← 行間の余白を追加
            }} >
              <div>{item.data.assetLabel || item.data.type.replace(/-\d+$/, '')}</div>
              <div style={{ marginLeft: '10px' }}>{removeTFromCode(item.data.code)}</div>
              <div style={{ marginLeft: '10px', color: '#a6a6a6' }}>{this.translateMessage('Start')}</div>
              <div >{item.data.inceptionDate} </div>
            </div>
            {/* 2行目 */}
            <div style={{
              //height:'25px'
              lineHeight: 1.4,
            }}>{item.data.fullName}</div>
          </div>
        )
        )}
      </div>
    );
  };



  ontipFormat = (value) => {
    const { defaultStartDate, actualEndDate } = this.state;
    let addDate = AddMonths(defaultStartDate, value);
    if (addDate > actualEndDate) {
      addDate = actualEndDate;
    }
    if (value === 0) {
      addDate = defaultStartDate
    }

    return DateTimeToString(addDate)

  }
  onChangePeriod = (value) => {
    const { periodMonths, defaultStartDate, actualEndDate } = this.state;
    let startDate = defaultStartDate
    if (value[0] === periodMonths) {
      startDate = actualEndDate
    } else if (value[0] === 0) {
      startDate = defaultStartDate
    } else {
      startDate = AddMonths(defaultStartDate, value[0]);
    }
    let endDate = AddMonths(defaultStartDate, value[1]);
    if (value[1] === periodMonths) endDate = actualEndDate
    let periodValue = [CalcMonths(defaultStartDate, new Date(startDate)), CalcMonths(defaultStartDate, endDate)]

    this.setState({
      startDate: startDate,
      endDate: endDate,
      periodValue,
      isCalcButtonDisabled: false,
    });
  };

  //20251225 UEDA 最適化計算に渡すボラティリティが下限を超えないようにする。
  onAfterChangeRisk = (value) => {

    if (this.blockNextRiskAfterChange) {
      this.blockNextRiskAfterChange = false;
      return;
    }

    const { displayMinVol, displayMaxVol, preVolRate } = this.state;
    const { minRisk, maxRisk } =
      this.getAccumulationSliderRiskBounds(displayMinVol, displayMaxVol);

    const requestedValue = this.getSliderNumericValue(value);

    if (!Number.isFinite(requestedValue)) {
      return;
    }

    const isCurrentlyOneYear =
      Math.abs(Number(this.state.volRate)) < 1e-6;

    const isOneYearEdge = Math.abs(requestedValue) < 1e-6;

    if (isCurrentlyOneYear && !isOneYearEdge && requestedValue > 0) {
      return;
    }

    if (isOneYearEdge) {
      this.blockNextRiskAfterChange = true;

      const riskFreeOnlyList = (this.state.optimalList || []).map((item) => ({
        ...item,
        optimalRatio: item.isRiskFreeAsset ? 100 : 0,
      }));

      const sortedRiskFreeOnlyList = this.getSortedOptimalList(
        riskFreeOnlyList,
        this.state.sortName,
        this.state.sortType
      );

      this.setState({
        optimalList: sortedRiskFreeOnlyList,
        volRate: 0,
        preVolRate: 0,
        riskInvestYear: 1,
        isCalcButtonDisabled: true,
        specifyFlg: false,
        optimalBtnDisabled: true,
        isRiskFreeOnlyAllocation: true,
        investVolRate: 0,
      }, () => {
        this.updateOptimalPieData(riskFreeOnlyList);
      });

      return;
    }

    if (!this.isRiskValueWithinBounds(requestedValue, { minRisk, maxRisk })) {
      return;
    }

    let v = this.clampRiskSliderValue(requestedValue, maxRisk, minRisk);
    if (!Number.isFinite(v)) return;

    if (preVolRate != null && v === preVolRate) {
      return;
    }

    this.setState(
      { volRate: v, preVolRate: v },
      () => {
        this.getOptimalDataByRisk(false, true);
      }
    );
  };

  onAfterChangePeriod = (value) => {
    const { prePeriodValue } = this.state;
    // 前回と同じなら何もしない
    if (
      prePeriodValue &&
      value[0] === prePeriodValue[0] &&
      value[1] === prePeriodValue[1]
    ) {
      return;
    }

    // 変わったときだけ実行
    this.setState(
      { prePeriodValue: value },
      () => {
        this.getOptimalDataByRisk(false, true, true);
      }
    );
  };


  onChangeRisk = (value) => {
    const { displayMinVol, displayMaxVol } = this.state;
    const { minRisk, maxRisk } =
      this.getAccumulationSliderRiskBounds(displayMinVol, displayMaxVol);

    const requestedValue = this.getSliderNumericValue(value);

    if (!Number.isFinite(requestedValue)) {
      return;
    }

    const requestedDisplayValue = requestedValue + 1;
    const isOneYearEdge = Math.abs(requestedValue) < 1e-6;

    if (isOneYearEdge) {
      this.blockNextRiskAfterChange = true;

      const riskFreeOnlyList = (this.state.optimalList || []).map((item) => ({
        ...item,
        optimalRatio: item.isRiskFreeAsset ? 100 : 0,
      }));

      const sortedRiskFreeOnlyList = this.getSortedOptimalList(
        riskFreeOnlyList,
        this.state.sortName,
        this.state.sortType
      );

      this.setState({
        optimalList: sortedRiskFreeOnlyList,
        volRate: 0,
        preVolRate: 0,
        riskInvestYear: 1,
        isCalcButtonDisabled: true,
        specifyFlg: false,
        optimalBtnDisabled: true,
        isRiskFreeOnlyAllocation: true,
        investVolRate: 0,
      }, () => {
        this.updateOptimalPieData(sortedRiskFreeOnlyList);
      });

      return;
    }


    if (
      !this.isRiskValueWithinBounds(
        requestedDisplayValue,
        { minRisk, maxRisk }
      )
    ) {
      this.blockNextRiskAfterChange = true;
      this.showAccumulationPeriodUnavailableToast();
      return;
    }

    const normalizedValue =
      this.clampRiskSliderValue(
        requestedValue,
        maxRisk,
        minRisk
      );

    this.setState({
      volRate: normalizedValue,
      riskInvestYear: this.clacRiskInvestYear(
        normalizedValue,
        displayMinVol,
        displayMaxVol
      ),
      isCalcButtonDisabled: false,
      specifyFlg: true,
      optimalBtnDisabled: false,
    });
  };



  onChangeInitAmount = (value) => {
    if (value === null) {
      value = 0
    }
    this.setState({ initAmount: value, isCalcButtonDisabled: false });
  };

  onChangeMonthlyAmount = (value) => {
    if (value === null) {
      value = 0
    }
    this.setState({ monthlyAmount: value, isCalcButtonDisabled: false })
  };

  onChangeInvestVolRate = (value) => {
    if (value === null) {
      value = 0
    }
    this.setState({ investVolRate: value, isCalcButtonDisabled: false })
  };
  onChangeInvestRetRate = (value) => {
    if (value === null) {
      value = 0
    }
    this.setState({ investRetRate: value, isCalcButtonDisabled: false })
  };
  onChangeInvestRetRateRec = (value) => {
    if (value === null) {
      value = 0
    }
    this.setState({ investRetRateRec: value, isCalcButtonDisabled: false })
  };

  onChangeInputTerm = (value) => {
    if (value === null) {
      value = 15
    }
    this.setState({
      investYear: value,
      isCalcButtonDisabled: false,
      specifyFlg: true
    })
  };
  onChangeRecPeriod = (value) => {
    if (value === null) {
      value = DEFAULT_RECEIVE_YEARS
    }
    this.setState({
      recPeriod: value,
      isCalcButtonDisabled: false
    })
  };


  handleClickCalcRatio = () => {
    //this.getOptimalData(false,true) 
    const { investVolRate, investRetRate, investRetRateRec, investYear, initAmount, monthlyAmount, recPeriod } = this.state;
    this.getSimulateData(investVolRate, investRetRate, investRetRateRec, investYear, initAmount, monthlyAmount, recPeriod, false);
  };

  handleClickSearchCheck = (item) => {
    const { searchResult, initialSelectedAssetIds } = this.state;
    if (item !== undefined) {
      const others = searchResult.filter(v => v.Select).length;
      if (others >= 20) {
        this.setState({
          errorMsg: this.translateMessage('SelectMaxNumStocks'),
        });
        return;
      }
      const tmpData = searchResult.map(v => {
        if (v.Code === item.Code) {
          return {
            ...v,
            Select: !v.Select,
          };
        }
        return v;
      });
      const selectCodes = this.getCanonicalInstrumentIdList(
        tmpData.filter((searchItem) => searchItem.Select)
      );
      let title = this.arraysEqual([...initialSelectedAssetIds], selectCodes) ? 'Close' : 'Apply';
      this.setState({
        searchResult: tmpData,
        assetSelectTitle: title
      });

    }
  }

  handleClickSearchUnCheck = (item) => {
    const { searchResult, initialSelectedAssetIds } = this.state;
    if (item !== undefined) {
      const tmpData = searchResult.map(v => {
        if (v.Code === item.Code) {
          return {
            ...v,
            Select: false,
          };
        }
        return v;
      });

      const selectCodes = this.getCanonicalInstrumentIdList(
        tmpData.filter((searchItem) => searchItem.Select)
      );
      let title = this.arraysEqual([...initialSelectedAssetIds], selectCodes) ? 'Close' : 'Apply';

      this.setState({
        searchResult: tmpData,
        errorMsg: '',
        assetSelectTitle: title
      });

    }
  }


  arraysEqual = (a, b) => {
    if (a.length !== b.length) return false;
    a.sort();
    b.sort();
    for (let i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  };


handleClickSearchFinish = () => {
  const { searchResult, optimalList, initialSelectedAssetIds } = this.state;
  const excludedValues = this.buildCanonicalInstrumentIdSet(optimalList);
  const selectedSearchItems = searchResult.filter((item) => item.Select);
  const selectCodes = this.getCanonicalInstrumentIdList(selectedSearchItems);

  if (this.arraysEqual([...initialSelectedAssetIds], selectCodes)) {
    this.setState({
      searchVisible: false,
      searchValue: '',
      searchResult: [],
      initialSelectedAssetIds: [],
    })
    return;
  }

  let addItems = selectedSearchItems
    .filter((item) => !excludedValues.has(this.getCanonicalInstrumentId(item)))
    .map((item) => ({
      ...this.buildOptimalListItem(item),
      selected: true,
    }));

  const updatedList = optimalList
    .filter((item) => selectedSearchItems.some((searchItem) => this.isSameInstrument(item, searchItem)))
    .map((item) => ({
      ...item,
      selected: false,
    }));

  const tmpData = [...updatedList, ...addItems];

  this.resetAfterAssetCompositionChange({
    optimalList: tmpData,
    searchVisible: false,
    searchValue: '',
    searchResult: [],
    initialSelectedAssetIds: [],
  });
}


  handleSearchAsset = (event) => {
    const { searchResult } = this.state;
    if (!event) return;

    const value = event.target.value || '';
    const q = value.trim().toLowerCase();

    const newSearchResult = (searchResult || []).map((item) => {
      const name = this.getNameLabel(item) || '';
      const asset = this.getAssetLabel(item) || '';
      const type = this.getTypeLabel(item) || (item.Type || item.type || '');
      const memo = (item.MemoEn || item.Memo || item.memo || ''); // MemoEnがあるなら優先

      const key = `${item.Code || item.code || ''} ${name} ${asset} ${type} ${memo}`.toLowerCase();

      return {
        ...item,
        Visible: (q === '' ? true : key.includes(q)),
      };
    });

    this.setState({
      searchResult: newSearchResult,
      searchValue: value,
    });
  };


  handleClickSelectDelete = (item) => {
    const { optimalList } = this.state;
    if (this.isRiskFreeAssetItem(item)) {
      return;
    }
    const updatedData = optimalList.filter(v => v.code !== item.code);
    this.resetAfterAssetCompositionChange({
      optimalList: updatedData,
    });
  };


  handleClickPriceDownload = async () => {
    this.setState({
      loading: true,
      tipMessage: this.translateMessage('Downloading')
    });
    try {
      const { optimalList, startDate, endDate, volRate, FixedDeposit, specifyFlg, recPeriod, DefaultCcy } = this.state;
      let data = {}
      data.type = 'PRICE-DOWNLOAD'
      //data.locale=this.state.locale
      data.locale = this.props.intl.locale
      data.isFirst = false
      data.specifyFlg = specifyFlg
      data.specifyTerm = false
      data.recPeriod = recPeriod
      data.volRate = volRate
      data.ccy = DefaultCcy
      data.startDate = DateTimeToString(startDate)
      data.endDate = DateTimeToString(endDate)
      data.optimalList = this.buildOptimalPayloadList(optimalList)
      data.FixedDeposit = FixedDeposit
      const result = await reqGetOptimalData(data)
      if (result.status === 0) {
        const downloadUrl = PRICEDOWNLOAD + result.data;
        console.log('[DEBUG-OPT-URL] handleClickPriceDownload.download', {
          base: PRICEDOWNLOAD,
          resultData: result.data,
          downloadUrl,
        });
        const response = await fetch(downloadUrl);
        if (!response.ok) {
          this.setState({
            loading: false
          });
          message.error('Download failed')
          return
        }
        const fileBlob = await response.blob();

        const url = window.URL.createObjectURL(fileBlob);
        const a = document.createElement('a');
        a.href = url;
        const today = new Date();
        const yyyymmdd = [
          today.getFullYear(),
          String(today.getMonth() + 1).padStart(2, '0'),
          String(today.getDate()).padStart(2, '0'),
        ].join('');
        a.download = `${yyyymmdd}_MarketData.xlsx`;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }


    } catch (error) {
      message.error('Download failed:', error.message);
    }
    this.setState({
      loading: false
    });
  };


  handleClickCorrelationDownload = async () => {
    this.setState({
      loading: true,
      tipMessage: this.translateMessage('Downloading')
    });
    try {
      const { optimalList, startDate, endDate, volRate, FixedDeposit, specifyFlg, recPeriod, DefaultCcy } = this.state;
      let data = {}
      data.type = 'CORRELATION-DOWNLOAD'
      //data.locale=this.state.locale
      data.locale = this.props.intl.locale
      data.isFirst = false
      data.specifyTerm = false
      data.specifyFlg = specifyFlg
      data.recPeriod = recPeriod
      data.volRate = volRate
      data.ccy = DefaultCcy
      data.startDate = DateTimeToString(startDate)
      data.endDate = DateTimeToString(endDate)
      data.optimalList = this.buildOptimalPayloadList(optimalList)
      data.FixedDeposit = FixedDeposit
      const result = await reqGetOptimalData(data)
      if (result.status === 0) {
        const downloadUrl = PRICEDOWNLOAD + result.data;
        console.log('[DEBUG-OPT-URL] handleClickCorrelationDownload.download', {
          base: PRICEDOWNLOAD,
          resultData: result.data,
          downloadUrl,
        });
        const response = await fetch(downloadUrl);
        if (!response.ok) {
          this.setState({
            loading: false
          });
          message.error('Download failed')
          return
        }
        const fileBlob = await response.blob();

        const url = window.URL.createObjectURL(fileBlob);
        const a = document.createElement('a');
        a.href = url;
        a.download = this.translateMessage('Correlation') + '.xlsx';
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      }


    } catch (error) {
      message.error('Download failed:', error.message);
    }
    this.setState({
      loading: false
    });
  };


  getETFData = async () => {
    //const result = await reqGetAllETFData(this.state.locale,'sim')
    const result = await reqGetAllETFData(this.props.intl.locale, 'sim');
    if (result.status === 0) {
      this.setState({
        assetETFData: (result.data || []).map(this.normalizeAssetETFItem),
        addAssetDisabled: false
      });
    }
  }

  getOptimalDataByRisk = async (isFirst, specifyTerm = true, periodChanged = false) => {

    this.setState({
      loading: true,
      tipMessage: this.translateMessage('Optimizing')
    });

    const { optimalList, startDate, endDate, volRate, FixedDeposit, specifyFlg, investYear, DefaultCcy, recPeriod, isValURL,
      minVol, maxVol, displayMinVol, displayMaxVol, investRetRate, investRetRateRec, investVolRate, investYearDisabled, investRetRateDisabled, investVolRateDisabled } = this.state;
    const selectedRiskValue = this.clampRiskSliderValue(volRate, maxVol);
    const selectedRiskInvestYear = this.clacRiskInvestYear(selectedRiskValue, displayMinVol, displayMaxVol);
    const riskFreeRate = parseFloat(Number(FixedDeposit ?? 0).toFixed(2));
    const shouldSkipOptimizeByRisk = this.shouldSkipOptimizeByRisk(selectedRiskValue, minVol);
    let tmpInvestYear = 0
    if (investYearDisabled) {
      tmpInvestYear = selectedRiskInvestYear
    } else {
      tmpInvestYear = investYear
    }
    let tmpinvestVolRate = 0
    let tmpinvestRetRate = 0
    if (investVolRateDisabled) {
      tmpinvestVolRate = selectedRiskValue
    } else {
      tmpinvestVolRate = investVolRate
    }
    if (investRetRateDisabled) {
      tmpinvestRetRate = riskFreeRate
    } else {
      tmpinvestRetRate = investRetRate
    }

    if (shouldSkipOptimizeByRisk) {
      this.applyRiskFreeOnlyAllocation({
        selectedRiskValue,
        retRate: riskFreeRate,
        investYear: tmpInvestYear,
        investVolRate: tmpinvestVolRate,
        investRetRate: tmpinvestRetRate,
        isValURL,
        investRetRateRec,
      });
      return;
    }

    let data = {}
    data.type = ''
    //data.locale=this.state.locale
    data.locale = this.props.intl.locale
    data.isFirst = isFirst
    data.specifyFlg = specifyFlg
    data.specifyTerm = specifyTerm
    data.volRate = selectedRiskValue
    data.recPeriod = recPeriod
    data.ccy = DefaultCcy
    data.periodChanged = periodChanged
    data.startDate = DateTimeToString(startDate)
    data.endDate = DateTimeToString(endDate)
    data.FixedDeposit = FixedDeposit
    data.optimalList = this.buildBackendOptimalPayloadList(optimalList);

    const result = await reqGetOptimalDataByRisk(data)
    if (result.status === 0) {

      let retRate = parseFloat(Number(result.data.optimalStats.ret).toFixed(2))
      if (result.data.isRiskFreeOnlyAllocation) {
        retRate = parseFloat(Number(result.data.FixedDeposit ?? 0).toFixed(2));
      }
      if (investRetRateDisabled) {
        tmpinvestRetRate = retRate
      }
      const normalizedOptimalList = (result.data.optimalList || []).map(this.normalizeOptimalListItem);
      const sortedOptimalList = this.getSortedOptimalList(
        normalizedOptimalList,
        this.state.sortName,
        this.state.sortType
      );

      const isRiskFreeOnlyAllocation = Boolean(result.data.isRiskFreeOnlyAllocation);
      const nextVolRate = isRiskFreeOnlyAllocation ? 0 : selectedRiskValue;
      this.setState({
        optimalList: sortedOptimalList,
        ratioImage: BASE + result.data.ratioImage,
        frontierChartHotspots: result.data.frontierChartHotspots || {},
        correlationImage: BASE + result.data.correlationImage,
        weakCorrelationPairs: this.normalizeCorrelationPairs(result.data.weakCorrelationPairs),
        strongCorrelationPairs: this.normalizeCorrelationPairs(result.data.strongCorrelationPairs),
        showDetailedAllocations: false,
        FixedDeposit: result.data.FixedDeposit ?? this.state.FixedDeposit,

        displayMinVol:
          Number.isFinite(Number(result.data.displayMinVol))
            ? Number(result.data.displayMinVol)
            : this.state.displayMinVol,

        displayMaxVol:
          result.data.displayMaxVol != null &&
          Number.isFinite(Number(result.data.displayMaxVol))
            ? Number(result.data.displayMaxVol)
            : this.state.displayMaxVol,

        isRiskFreeOnlyAllocation: isRiskFreeOnlyAllocation,

        investVolRate: isRiskFreeOnlyAllocation ? 0 : tmpinvestVolRate,
        investRetRate: tmpinvestRetRate,
        retRate: retRate,

        volRate: nextVolRate,
        preVolRate: nextVolRate,

        investYear: tmpInvestYear,
        riskInvestYear: selectedRiskInvestYear,
      });
      this.updateOptimalPieData(normalizedOptimalList);


      if (periodChanged) {

        let checked = []
        let names = normalizedOptimalList.map((item, index) => {
          let title = item.type + '(' + removeTFromCode(item.code) + ')'
          if (item.optimalRatio !== 0) {
            checked.push(title)
          }
          return title
        });
        let marketColors = result.data.marketData.header.map(value => {
        const color = this.getMarketSeriesColor(value, normalizedOptimalList);
        return checked.includes(value) ? hexToRgb(color) : hexToRgba(color);
      })
        this.setState((prevState) => ({
          config: {
            ...prevState.config,
            yAxis: {
              ...prevState.config.yAxis,
              min: result.data.marketData.min,
              max: result.data.marketData.max,
            },
            data: result.data.marketData.market,
            color: marketColors,
            header: result.data.marketData.header,
            names: names,
            checked: checked,
          }
        }));
      }


      this.setState({
        loading: false
      });
      if (isValURL) {
        this.getSimulateData(tmpinvestVolRate, tmpinvestRetRate, investRetRateRec,
          tmpInvestYear,
          this.state.initAmount, this.state.monthlyAmount, this.state.recPeriod, isFirst)
      }


    } else {
      message.error(getApiErrorMessage(
        result.data,
        getLocaleFallbackMessage(this.props.intl?.locale, 'リスク・リターン計算に失敗しました', 'Failed to calculate risk/return')
      ))
      this.setState({
        loading: false
      });
    }

  }



  getOptimalData = async (isFirst, specifyTerm = true) => {
    this.setState({
      loading: true,
      tipMessage: this.translateMessage('Optimizing')
    });

    const { optimalList, startDate, endDate, volRate, FixedDeposit, specifyFlg, investYear, recPeriod, isValURL, investRetRateRec,
      DefaultCcy, investRetRate, investVolRate, investYearDisabled, investRetRateDisabled, investVolRateDisabled } = this.state;
    let data = {}
    data.type = ''
    //data.locale=this.state.locale
    data.locale = this.props.intl.locale
    data.isFirst = isFirst
    data.specifyFlg = specifyFlg
    data.specifyTerm = specifyTerm
    data.volRate = volRate
    data.recPeriod = recPeriod
    data.ccy = DefaultCcy
    data.startDate = DateTimeToString(startDate)
    data.endDate = DateTimeToString(endDate)
    data.FixedDeposit = FixedDeposit
    data.optimalList = this.buildBackendOptimalPayloadList(optimalList);
    const result = await reqGetOptimalData(data)


    if (result.status === 0) {
      let minVol = parseFloat(Number(parseFloat(result.data.minStats.vol)).toFixed(2))
      let maxVol = Math.floor(result.data.maxStats.vol * 100) / 100
      const responseDisplayMinVol = Number.isFinite(Number(result.data.displayMinVol))
        ? parseFloat(Number(result.data.displayMinVol).toFixed(2))
        : minVol;
      
      const responseDisplayMaxVolRaw = Number.isFinite(Number(result.data.displayMaxVol))
        ? Number(result.data.displayMaxVol)
        : maxVol;
      const responseDisplayMaxVol = Math.floor(responseDisplayMaxVolRaw * 100) / 100;
      const sliderMinVol = this.getRiskSliderMinValue();
      let step = (responseDisplayMaxVol - sliderMinVol) / 6;
      let vol1 = parseFloat(Number(parseFloat(sliderMinVol + step)).toFixed(2))
      let vol2 = parseFloat(Number(parseFloat(sliderMinVol + step * 2)).toFixed(2))
      let vol3 = parseFloat(Number(parseFloat(sliderMinVol + step * 3)).toFixed(2))
      let vol4 = parseFloat(Number(parseFloat(sliderMinVol + step * 4)).toFixed(2))
      let vol5 = parseFloat(Number(parseFloat(sliderMinVol + step * 5)).toFixed(2))
      let vol = parseFloat(Number(result.data.optimalStats.vol).toFixed(2))
      const riskFreeRate = parseFloat(Number(result.data.FixedDeposit ?? FixedDeposit ?? 0).toFixed(2));

      
      const labels = [
        { value: sliderMinVol, age: this.formatYearsValue(1) },
        { value: vol1, age: this.formatYearsValue(5) },
        { value: vol2, age: this.formatYearsValue(10) },
        { value: vol3, age: this.formatYearsValue(15) },
        { value: vol4, age: this.formatYearsValue(20) },
        { value: vol5, age: this.formatYearsValue(25) },
        { value: responseDisplayMaxVol, age: this.getAccumulationPeriodMarkText(30) },
      ];

      const newMarks = {};
      for (let i = 0; i < labels.length; i++) {
        if (i === labels.length - 1) {
          newMarks[labels[i].value] = {
            label: <span style={{ fontSize: '12px', marginLeft: '-5px' }}>{labels[i].age}</span>,
          };
        } else {
          newMarks[labels[i].value] = {
            label: <span style={{ fontSize: '12px' }}>{labels[i].age}</span>,
          };
        }
      }


      let tmpInvestYear = 0
      if (investYearDisabled) {
        tmpInvestYear = this.clacRiskInvestYear(vol, responseDisplayMinVol, responseDisplayMaxVol)
      } else {
        tmpInvestYear = investYear
      }

      let retRate = parseFloat(Number(result.data.optimalStats.ret).toFixed(2))
      let tmpinvestVolRate = 0
      let tmpinvestRetRate = 0
      if (investVolRateDisabled) {
        tmpinvestVolRate = vol
      } else {
        tmpinvestVolRate = investVolRate
      }
      if (investRetRateDisabled) {
        tmpinvestRetRate = retRate
      } else {
        tmpinvestRetRate = investRetRate
      }

      let newStartDate = moment(result.data.startDate, 'YYYY-MM-DD').toDate();
      let newEndDate = moment(result.data.endDate, 'YYYY-MM-DD').toDate();
      const normalizedOptimalList = (result.data.optimalList || []).map(this.normalizeOptimalListItem);
      const sortedOptimalList = this.getSortedOptimalList(
        normalizedOptimalList,
        this.state.sortName,
        this.state.sortType
      );
      const isJapaneseStockOnlyList = this.shouldOmitJapaneseStockPrefix(normalizedOptimalList);
      const responseMaxVol = labels[labels.length - 1].value;
      const selectedPeriodValue = [
        0,
        CalcMonths(newStartDate, newEndDate)
      ];
      const responseState = {
        isCalcButtonDisabled: true,
        ratioImage: BASE + result.data.ratioImage,
        frontierChartHotspots: result.data.frontierChartHotspots || {},
        correlationImage: BASE + result.data.correlationImage,
        weakCorrelationPairs: this.normalizeCorrelationPairs(result.data.weakCorrelationPairs),
        strongCorrelationPairs: this.normalizeCorrelationPairs(result.data.strongCorrelationPairs),
        showDetailedAllocations: false,
        isJapaneseStocksMode: isFirst ? false : this.state.isJapaneseStocksMode,
        defaultCompositeOptimalList: isFirst && !isJapaneseStockOnlyList
          ? this.cloneOptimalList(normalizedOptimalList)
          : this.state.defaultCompositeOptimalList,
        marks: newMarks,
        minVol: minVol,
        maxVol: maxVol,
        displayMinVol: responseDisplayMinVol,
        displayMaxVol: responseMaxVol,
        FixedDeposit: result.data.FixedDeposit,
        displayCcy: 1,
        defaultStartDate: newStartDate,
        startDate: newStartDate,
        endDate: newEndDate,
        actualEndDate: newEndDate,
        periodMonths: CalcMonths(newStartDate, newEndDate),
        periodValue: selectedPeriodValue,
        prePeriodValue: selectedPeriodValue,
        ...(!specifyFlg ? {
          optimalVol: vol,
          optimalBtnDisabled: true,
        } : {}),
      };

      if (this.shouldSkipOptimizeByRisk(vol, minVol)) {
        if (investRetRateDisabled) {
          tmpinvestRetRate = riskFreeRate;
        }
        this.applyRiskFreeOnlyAllocation({
          selectedRiskValue: vol,
          retRate: riskFreeRate,
          investYear: tmpInvestYear,
          investVolRate: tmpinvestVolRate,
          investRetRate: tmpinvestRetRate,
          isValURL,
          investRetRateRec,
          optimalList: normalizedOptimalList,
          fixedDeposit: result.data.FixedDeposit ?? FixedDeposit,
          minVol,
          maxVol,
          displayMinVol: responseDisplayMinVol,
          displayMaxVol: responseMaxVol,
          additionalState: responseState,
        });
        return;
      }


      this.setState({
        ...responseState,
        optimalList: sortedOptimalList,
        volRate: vol,
        preVolRate: vol,
        investYear: tmpInvestYear,
        investVolRate: tmpinvestVolRate,
        investRetRate: tmpinvestRetRate,
        riskInvestYear: this.clacRiskInvestYear(vol, responseDisplayMinVol, responseMaxVol),
        retRate: retRate,
      });
      this.updateOptimalPieData(normalizedOptimalList);

      let checked = []
      let names = normalizedOptimalList.map((item, index) => {
        let title = item.type + '(' + removeTFromCode(item.code) + ')'
        if (item.optimalRatio !== 0) {
          checked.push(title)
        }
        return title
      });
      let marketColors = result.data.marketData.header.map(value => {
          const color = this.getMarketSeriesColor(value, normalizedOptimalList);
          return checked.includes(value) ? hexToRgb(color) : hexToRgba(color);
        })
      this.setState((prevState) => ({
        config: {
          ...prevState.config,
          yAxis: {
            ...prevState.config.yAxis,
            min: result.data.marketData.min,
            max: result.data.marketData.max,
          },
          data: result.data.marketData.market,
          color: marketColors,
          header: result.data.marketData.header,
          names: names,
          checked: checked,
        }
      }));
      this.setState({
        loading: false
      });
      if (isValURL) {
        this.getSimulateData(tmpinvestVolRate, tmpinvestRetRate, investRetRateRec, tmpInvestYear, this.state.initAmount, this.state.monthlyAmount, this.state.recPeriod, isFirst)
      }


    } else {
      message.error(getApiErrorMessage(
        result.data,
        getLocaleFallbackMessage(this.props.intl?.locale, '最適化に失敗しました', 'Optimization failed')
      ))
      this.setState({
        loading: false
      });
    }

  }



  getSimulateData = async (volRate, retRate, retRateRec, investYear, initAmount, monthlyAmount, recPeriod, isFirst) => {
    this.setState({
      loading: true,
      tipMessage: (isFirst ? this.translateMessage('Optimizing') : this.translateMessage('Recalculating'))
    });
    let data = {}
    //data.locale=this.state.locale
    data.locale = this.props.intl.locale
    data.retRate = retRate
    data.retRateRec = retRateRec
    data.recPeriod = recPeriod
    data.volRate = volRate
    data.year = investYear
    if (initAmount === null) {
      data.initAmount = 0
      this.setState({
        initAmount: 0
      });
    } else {
      data.initAmount = initAmount
    }
    if (monthlyAmount === null) {
      data.monthlyAmount = 0
      this.setState({
        monthlyAmount: 0
      });
    } else {
      data.monthlyAmount = monthlyAmount
    }
    const result = await reqGetSimulateData(data)
    if (result.status === 0) {
      let amountInvested = Math.round(Number(result.data.amountInvested))
      let valueBeforeTax = Math.round(Number(result.data.valueBeforeTax))
      let valueAfterTax = Math.round(Number(result.data.valueAfterTax))
      let valueAfterTaxExNISA = Math.round(Number(result.data.valueAfterTaxExNISA))
      let valueTax = parseFloat(Number(parseFloat(result.data.valueTax)).toFixed(3))
      let payMonthly = parseFloat(Number(parseFloat(result.data.payMonthly)).toFixed(2))
      let valueRate = valueBeforeTax / amountInvested
      // let simulationMsg =[
      // `${investYear}年後の`,
      // `資産価値は${numFormat(valueBeforeTax)}万円。税`,
      // `(${valueTax}％)`,
      // `引後は${numFormat(valueAfterTax)}万円。NISA`,
      // '(1800万円非課税)',
      // `活用時は${numFormat(valueAfterTaxExNISA)}万円。`]

      let unit = 1
      if (this.state.locale !== 'ja') {
        unit = 100
      }

      let simulationMsg = [
        formatString(this.translateMessage('NisaMessage1'), [investYear, amountInvested / unit]),
        formatString(this.translateMessage('NisaMessage2'), [valueBeforeTax / unit, rateFixed1(valueRate, 1)]),
        formatString(this.translateMessage('NisaMessage3'), [valueAfterTax / unit, numFormat(valueAfterTaxExNISA / unit)])
      ]

      //`${investYear}年後の資産額は${numFormat(valueBeforeTax)}万円、税(${valueTax}％)引き後は${numFormat(valueAfterTax)}万円、NISA活用時は${numFormat(valueAfterTaxExNISA)}万円`
      this.setState({
        futureSimulationImage: BASE + result.data.simulationImage,
        valueBeforeTax,
        valueAfterTax,
        valueAfterTaxExNISA,
        valueTax,
        simulationMsg,
        payMonthly
      });

    } else {
      message.error(getApiErrorMessage(
        result.data,
        getLocaleFallbackMessage(this.props.intl?.locale, '将来シミュレーションに失敗しました', 'Future simulation failed')
      ))
    }
    this.setState({
      loading: false
    });
  }

  clacRiskInvestYear(vol, minVol, maxVol) {
    const sliderMinVol = this.getRiskSliderMinValue();
    const normalizedVol = this.clampRiskSliderValue(vol, maxVol);
    if (!Number.isFinite(Number(maxVol)) || Number(maxVol) <= sliderMinVol) {
      return 0;
    }
    if (normalizedVol <= sliderMinVol) return 0;
    if (normalizedVol >= maxVol) return 30;
    return Math.round(((normalizedVol - sliderMinVol) / (maxVol - sliderMinVol)) * 30)
  }

  handleOptimalVolClick = () => {
    const { optimalVol, displayMinVol, displayMaxVol } = this.state;
    this.setState({
      volRate: optimalVol,
      riskInvestYear: this.clacRiskInvestYear(optimalVol, displayMinVol, displayMaxVol),
      optimalBtnDisabled: true,
      isCalcButtonDisabled: false,
      specifyFlg: false,
    }, () => {
      this.getOptimalDataByRisk(false, true);
    });

  }

  handleSecClick = (code) => {
    const { optimalList } = this.state;
    const updatedData = optimalList.map(v => {
      if (v.code === code) {
        return {
          ...v,
          selected: true,
        };
      }
      return {
        ...v,
        selected: false,
      };
    });
    this.setState({ optimalList: updatedData });
  };

handleAssetSearchSort = (field = 'asset') => {
  this.setState((prevState) => ({
    assetSearchSortField: field,
    assetSearchSortOrder:
      prevState.assetSearchSortField !== field
        ? 'asc'
        : prevState.assetSearchSortOrder === ''
          ? 'asc'
          : prevState.assetSearchSortOrder === 'asc'
            ? 'desc' : '',
  }));
};

handleAddAsset = () => {
  const { assetETFData, optimalList } = this.state;
  const excludedValues = this.buildCanonicalInstrumentIdSet(optimalList);

  const searchResult = assetETFData.filter((item) => (
    !excludedValues.has(this.getCanonicalInstrumentId(item))
  ));

  const sortedData = [...searchResult].sort((a, b) => {
    const key1 = `${this.getAssetLabel(a)}${a.id || ''}`;
    const key2 = `${this.getAssetLabel(b)}${b.id || ''}`;
    return key1.localeCompare(key2);
  });

  let tmpData1 = sortedData.map((item) => ({
    Asset: this.getAssetLabel(item),
    Ccy: item.Ccy,
    Name: this.getNameLabel(item),
    Code: item.Code,
    isRiskFreeAsset: this.normalizeRiskFreeFlag(item),
    Color: item.Color,
    FullName: this.getNameLabel(item),
    Provider: item.Provider,
    InceptionDate: item.InceptionDate,
    Benchmark: item.Benchmark,
    URL: item.URL,
    ISIN: item.ISIN,
    Memo: item.Memo,
    Id: item.id,
    Select: false,
    Visible: true
  }));

  const exsistData = assetETFData.filter((item) => (
    excludedValues.has(this.getCanonicalInstrumentId(item))
  ));
  let tmpData2 = exsistData.map((item) => ({
    Asset: this.getAssetLabel(item),
    Name: item.Name,
    Ccy: item.Ccy,
    Code: item.Code,
    isRiskFreeAsset: this.normalizeRiskFreeFlag(item),
    Color: item.Color,
    FullName: this.getNameLabel(item),
    Provider: item.Provider,
    InceptionDate: item.InceptionDate,
    Benchmark: item.Benchmark,
    URL: item.URL,
    ISIN: item.ISIN,
    Memo: item.Memo,
    Id: item.id,
    Select: true,
    Visible: true,
  }));

  let tmpData3 = [...tmpData2, ...tmpData1];

  this.setState({
    searchVisible: true,
    errorMsg: '',
    searchValue: '',
    searchResult: tmpData3,
    initialSelectedAssetIds: this.getCanonicalInstrumentIdList(tmpData2),
    assetSearchSortOrder: '',
    assetSearchSortField: 'asset',
    assetSelectTitle: 'Close'
  });
};

  buildOptimalListItem = (item, options = {}) => {
    const {
      useRequestedStockId = false,
      assetETFData = this.state.assetETFData,
    } = options;
    const code = useRequestedStockId
      ? this.getRequestedStockIdForAsset(item)
      : item.Code;

    const displayType = useRequestedStockId
      ? (item.Sector || item.sector || this.getAssetLabel(item))
      : this.getAssetLabel(item);

    return {
    selected: false,
    key: code,
    type: this.getAssetLabel(item),
    displayType,
    ccy: item.Ccy,
    code,
    optimalRatio: 0.0,
    returnRatio: 0.0,
    riskRatio: 0.0,
    express: '>=',
    expressValue: 0,
    isRiskFreeAsset: this.normalizeRiskFreeFlag(item),
    color: this.getItemColor(item),
    fullName: this.getNameLabel(item),
    provider: item.Provider,
    benchmark: useRequestedStockId
      ? this.resolveRequestedBenchmarkId(item, assetETFData)
      : item.Benchmark,
    inceptionDate: item.InceptionDate,
    url: item.URL,
    isin: item.ISIN,
    };
  };



  handleSetJapaneseStocks = () => {
    const { assetETFData } = this.state;

    const assetByIsin = new Map(
      assetETFData
        .map((item) => [String(item.ISIN || '').trim(), item])
        .filter(([isin]) => isin !== '')
    );

    const matchedItems = JAPANESE_STOCK_ISINS.map((isin) => assetByIsin.get(isin));

    const missingCodes = JAPANESE_STOCK_ISINS.filter(
      (isin, index) => !matchedItems[index]
    );

    if (missingCodes.length > 0) {
      message.error(
        `日本株17銘柄の一部を読み込めませんでした: ${missingCodes.join(', ')}`
      );
      return;
    }

    const newOptimalList = matchedItems.map((item) => (
      this.buildOptimalListItem(item, {
        useRequestedStockId: true,
        assetETFData,
      })
    ));

    this.resetAfterAssetCompositionChange({
      optimalList: newOptimalList,
      isJapaneseStocksMode: true,
    });
  };


  handleRestoreCompositeAssets = () => {
    const { defaultCompositeOptimalList } = this.state;

    if (defaultCompositeOptimalList.length === 0) {
      message.error('複合資産の初期データを読み込めませんでした');
      return;
    }
    this.resetAfterAssetCompositionChange({
      optimalList: this.cloneOptimalList(defaultCompositeOptimalList),
      isJapaneseStocksMode: false,
    });
  };

  handleToggleJapaneseStocks = () => {
    if (this.state.isJapaneseStocksMode) {
      this.handleRestoreCompositeAssets();
      return;
    }
    this.handleSetJapaneseStocks();
  };


  customFilterOption = (inputValue, option) => {
    const excludedValues = this.getEditableOptimalCodes(this.state.optimalList);
    const labelLower = option.label.toLowerCase();
    return (
      labelLower.includes(inputValue.toLowerCase()) &&
      !excludedValues.includes(option.value)
    );
  };

  handleDragStart = (index) => {
    this.setState({
      draggedFromIndex: index,
      isDragging: false
    });
  };

  handleDragOver = (index) => {
    const { draggedFromIndex } = this.state;
    if (draggedFromIndex === -1) {
      this.setState({
        isDragging: false
      });
    }
    this.setState({
      draggedToIndex: index,
      isDragging: true
    });
  };

  handleSortClick = (name) => {
    const { sortName, sortType } = this.state;
    //let name ='type'
    let tmpSortName;
    let tmpSortType;
    if (sortName === '' || name !== sortName) {
      tmpSortName = name;
      tmpSortType = 'ASC';
    } else {
      tmpSortName = name;
      tmpSortType = (sortType === 'ASC' ? 'DESC' : 'ASC');
    }
    this.sortData(tmpSortName, tmpSortType);
  };
  getSortedOptimalList = (optimalList = this.state.optimalList, sortName = this.state.sortName, sortType = this.state.sortType) => {
    return [...optimalList].sort((a, b) => {
      if (sortType === 'ASC') {
        if (a[sortName] < b[sortName]) {
          return -1;
        }
        if (a[sortName] > b[sortName]) {
          return 1;
        }
        return 0;
      } else {
        if (a[sortName] > b[sortName]) {
          return -1;
        }
        if (a[sortName] < b[sortName]) {
          return 1;
        }
        return 0;
      }
    });
  };

  sortData(sortName, sortType, optimalList = this.state.optimalList) {
    const sortedData = this.getSortedOptimalList(optimalList, sortName, sortType);
    this.setState({
      sortName: sortName,
      sortType: sortType,
      optimalList: sortedData
    });

  }
  handleDragEnd = () => {
    const { draggedFromIndex, draggedToIndex, optimalList } = this.state;

    if (draggedFromIndex === -1 || draggedToIndex === -1 || draggedFromIndex === draggedToIndex) return;
    const newData = [...optimalList];
    const fromItem = newData[draggedFromIndex];;
    const toItem = newData[draggedToIndex];
    newData[draggedFromIndex] = toItem;
    newData[draggedToIndex] = fromItem;
    this.setState({ optimalList: newData });

    this.setState({
      draggedFromIndex: -1,
      draggedToIndex: -1,
      isDragging: false
    })
  };
  onChangeDisplayCcy = (e) => {
    const { config } = this.state;
    this.setState({
      displayCcy: e.target.value
    })
    let data = config.data;
    if (e.target.value === 2) {

      let firstDate = ""
      let firstRate = 0;
      let fxRates = []
      const updatedData = data.map((item, idx) => {
        const nextItem = { ...item };
        if (idx === 0) {
          firstDate = item.x
        }
        if (item.x === firstDate) {
          firstRate = item.y / item.fx
          nextItem.u = 1
          fxRates.push({
            key: item.z,
            value: firstRate
          });
        } else {
          let v = fxRates.filter(v => v.key === item.z)
          if (v) {
            nextItem.u = item.y / item.fx / v[0].value
          }
        }
        return nextItem;
      });

      this.setState((prevState) => ({
        config: {
          ...prevState.config,
          data: updatedData,
          yField: 'u',
        }
      }));
    } else {
      this.setState((prevState) => ({
        config: {
          ...prevState.config,
          yField: 'y',
        }
      }));
    }

  };
  onChangeEnabled = (item, e) => {
    const { config, optimalList } = this.state;
    this.setState({
      loading: true,
      tipMessage: ''
    });
    const newChecked = e.target.checked ? [...config.checked, item] : config.checked.filter((v) => v !== item);
    let marketColors = config.header.map(value => {
      const color = this.getMarketSeriesColor(value, optimalList);
      return newChecked.includes(value) ? hexToRgb(color) : hexToRgba(color);
    })
    this.setState((prevState) => ({
      config: {
        ...prevState.config,
        checked: newChecked,
        color: marketColors,
      }
    }))

    setTimeout(() => {
      this.setState({ loading: false });
    }, 1000);

  };

  onChangeConditionExpress = (code) => (value) => {
    const { ratioSettingList } = this.state;
    const updatedData = ratioSettingList.map(item => {
      if (item.code === code) {
        return {
          ...item,
          express: normalizeConstraintOperator(value) || '=',
        };
      }
      return item;
    });
    this.setState({ ratioSettingList: updatedData, ratioSelectTitle: this.translateMessage('Apply') });
  };
  normalizePercentInputValue = (rawValue, fallbackValue = 0) => {
    if (rawValue === null || rawValue === undefined || rawValue === '') {
      return fallbackValue;
    }

    const numericValue = typeof rawValue === 'number'
      ? rawValue
      : Number(String(rawValue).replace(/[%\s,]/g, ''));

    if (!Number.isFinite(numericValue)) {
      return fallbackValue;
    }

    return Math.min(100, Math.max(0, numericValue));
  };
  updateRatioSettingExpressValue = (code, rawValue) => {
    const nextExpressValue = this.normalizePercentInputValue(rawValue, 0);
    const { ratioSettingList } = this.state;
    const updatedData = ratioSettingList.map(item => {
      if (item.code === code) {
        return {
          ...item,
          expressValue: nextExpressValue,
        };
      }
      return item;
    });

    this.setState({ ratioSettingList: updatedData, ratioSelectTitle: this.translateMessage('Apply') });
  };
  onChangeConditionExpressValue = (code) => (value) => {
    this.updateRatioSettingExpressValue(code, value);
  };
  onBlurConditionExpressValue = (code) => (event) => {
    this.updateRatioSettingExpressValue(code, event?.target?.value);
  };
  onChangeObservValue = (valueOrEvent) => {
    const nextValue = valueOrEvent?.target ? valueOrEvent.target.value : valueOrEvent;

    this.setState({
      newObservValue: nextValue,
      ratioSelectTitle: this.translateMessage('Apply')
    });
  };
  onChangeDefaultCcy = (v) => {

    this.setState({
      DefaultCcySetting: v,
      ratioSelectTitle: this.translateMessage('Apply')
    });
  };
  onChangeShowObsPeriod = (v) => {

    this.setState({
      ShowObservationPeriodSetting: v,
      ratioSelectTitle: this.translateMessage('Apply')
    });
  };

  openRatioSettingDrawer = (drawerType) => {
    const { optimalList, FixedDeposit, observValue, DefaultCcy, ShowObservationPeriod } = this.state;
    const ratioSettingList = optimalList.map(item => ({
      ...item,
      express: normalizeConstraintOperator(item?.express) || '=',
    }));
    this.setState({
      settingVisible2: drawerType === 'asset',
      settingVisible3: drawerType === 'other',
      ratioSettingList,
      FixedDepositSetting: FixedDeposit,
      newObservValue: observValue,
      DefaultCcySetting: DefaultCcy,
      ShowObservationPeriodSetting: ShowObservationPeriod,
      ratioSelectTitle: this.translateMessage('Close')
    })
  };

  handleRatioSettingOn = () => {
    this.openRatioSettingDrawer('asset');
  };

  handleOtherSettingOn = () => {
    this.openRatioSettingDrawer('other');
  };

  isRatioConstraintTarget = (item) => {
    if (!item || !item.code) {
      return false;
    }
    if (this.shouldHideNonJapaneseStockInJapaneseStocksMode(item)) {
      return false;
    }
    return !this.isRiskFreeAssetItem(item);
  };

  finalizeRatioSettings = () => {
    const { optimalList, ratioSettingList, FixedDeposit, FixedDepositSetting, observValue, newObservValue, DefaultCcy, DefaultCcySetting, ShowObservationPeriodSetting } = this.state;

    let needCalc = false;

    const updatedData = optimalList.map(item => {
      const newItem = ratioSettingList.find(m => m.code === item.code);
      if (!newItem) {
        return item;
      }
      const expressValueChanged = newItem.expressValue !== item.expressValue;
      const nextExpress = normalizeConstraintOperator(newItem.express) || '=';
      const currentExpress = normalizeConstraintOperator(item.express) || '=';
      const expressChanged = nextExpress !== currentExpress;
      if (!expressValueChanged && !expressChanged) {
        return item;
      }
      needCalc = true;
      return {
        ...item,
        expressValue: expressValueChanged ? newItem.expressValue : item.expressValue,
        express: expressChanged ? nextExpress : currentExpress,
      };
    });

    if (FixedDeposit !== FixedDepositSetting) {
      needCalc = true;
    }
    if (observValue !== newObservValue) {
      needCalc = true;
    }
    if (DefaultCcy !== DefaultCcySetting) {
      needCalc = true;
    }
    const d = this.getObservationBaselineDate(newObservValue);
    const periodMonths = CalcMonths(d, CONSTEndDate);
    this.setState({
      settingVisible2: false,
      settingVisible3: false,
      FixedDeposit: FixedDepositSetting,
      observValue: newObservValue,
      DefaultCcy: DefaultCcySetting,
      ShowObservationPeriod: ShowObservationPeriodSetting,
      defaultStartDate: d,
      periodMonths,
      periodValue: [0, periodMonths],
      prePeriodValue: [0, periodMonths],
      startDate: d,
      endDate: CONSTEndDate,
      optimalList: updatedData
    }, () => {
      if (needCalc) {
        this.getOptimalData(false, true);
      }
    })
  };
  handleRatioSettingOff = () => {
    const activeElement = typeof document !== 'undefined' ? document.activeElement : null;
    if (activeElement && typeof activeElement.blur === 'function') {
      activeElement.blur();
    }

    setTimeout(() => {
      this.finalizeRatioSettings();
    }, 0);
  };


  componentDidMount() {
    this.getETFData()
    this.getOptimalData(true, false)
  }


  //20260108 UEDA 
  componentDidUpdate(prevProps, prevState) {
    const prevLocale = prevProps.intl?.locale;
    const nextLocale = this.props.intl?.locale;
    //ロケールが変わったら再表示
    if (prevLocale && nextLocale && prevLocale !== nextLocale) {
      this.getETFData();
      this.getOptimalData(true, false);
      return;
    }

    const boundsChanged = prevState.displayMinVol !== this.state.displayMinVol || prevState.displayMaxVol !== this.state.displayMaxVol;
    if (!boundsChanged) {
      return;
    }

    const nextRiskValue = this.getSelectableRiskValue(
      this.state.volRate,
      this.state.displayMinVol,
      this.state.displayMaxVol
    );
    if (nextRiskValue === this.state.volRate) {
      return;
    }

    this.setState({
      volRate: nextRiskValue,
      preVolRate: nextRiskValue,
      riskInvestYear: this.clacRiskInvestYear(nextRiskValue, this.state.displayMinVol, this.state.displayMaxVol),
      ...(this.state.investVolRateDisabled ? { investVolRate: nextRiskValue } : {}),
    });
  }


  render() {
    const headerTitleElement = typeof document === 'undefined' ? null : document.getElementById('page-header-title');
    const { startDate, actualEndDate, periodValue, periodMarks, periodMonths, volRate, searchValue, sortName, sortType, settingVisible1, settingVisible2, settingVisible3, loading, ratioSettingList,
      isDragging, optimalList, marks, displayMinVol, displayMaxVol, retRate, config, optimalPieData, optimalBtnDisabled, isCalcButtonDisabled, investVolRate, investRetRate, assetSelectTitle, ratioSelectTitle,
      futureSimulationImage, investYear, initAmount, monthlyAmount, addAssetDisabled, searchResult, newObservValue, searchVisible, tipMessage, errorMsg, FixedDepositSetting, simulationMsg, riskInvestYear,
      investYearDisabled, investRetRateDisabled, investRetRateRec, investRetRateRecDisabled, investVolRateDisabled, isValURL, DefaultCcySetting,
      recPeriodDisabled, ratioImage, correlationImage, recPeriod, payMonthly, valueBeforeTax, ShowObservationPeriodSetting, ShowObservationPeriod, showDetailedAllocations,
      isJapaneseStocksMode, weakCorrelationPairs, strongCorrelationPairs, isFutureAssetSimulationDescriptionOpen, isPortfolioTitleDescriptionOpen, isInvestmentStyleDescriptionOpen, isAccumulationPeriodDescriptionOpen, isRecommendedAllocationDescriptionOpen, isAllocationListDescriptionOpen, isPriceGraphDescriptionOpen, isRiskReturnDistributionDescriptionOpen, isCorrelationMapDescriptionOpen } = this.state

    const visibleOptimalList = this.getVisibleOptimalList(
      optimalList,
      showDetailedAllocations,
      isJapaneseStocksMode
    );
    const visibleRatioConstraintItems = ratioSettingList.filter(this.isRatioConstraintTarget);
    const hiddenAllocationCount = optimalList.filter(
      (item) => !this.shouldDisplayAllocationRow(item, false, isJapaneseStocksMode)
    ).length;
    const showDetailToggle = hiddenAllocationCount > 0;
    const selectedInvestmentStyle = this.getSelectedInvestmentStyle(volRate);
    const accumulationSliderRiskBounds = this.getAccumulationSliderRiskBounds(
      displayMinVol,
      displayMaxVol
    );
    const accumulationSliderMarks = this.getAccumulationSliderMarks(
      accumulationSliderRiskBounds,
      marks
    );
    const accumulationSliderRailStyle = this.getAccumulationSliderRailStyle(
      accumulationSliderRiskBounds,
      displayMaxVol
    );
    const accumulationSliderRailCssVars = this.getAccumulationSliderRailCssVars(
      accumulationSliderRiskBounds,
      displayMaxVol
    );
    const accumulationSliderValue = this.clampRiskSliderValue(
      volRate,
      accumulationSliderRiskBounds.maxRisk,
      accumulationSliderRiskBounds.minRisk
    );
    const futureAssetSimulationTitleToggle = (
      <h1 className='portfolio-proposal-main-heading'>
        <button
          type='button'
          className='portfolio-proposal-accordion-toggle'
          aria-expanded={isFutureAssetSimulationDescriptionOpen}
          data-testid='future-asset-simulation-description-toggle'
          onClick={() => this.setState({
            isFutureAssetSimulationDescriptionOpen: !isFutureAssetSimulationDescriptionOpen,
          })}
        >
          <span className='portfolio-proposal-title'><FormattedMessage id='FutureAssetSimulation' /></span>
          <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
        </button>
      </h1>
    );
    const PortfolioHeadingTag = isValURL ? 'h2' : 'h1';
    const portfolioTitleToggle = (
      <PortfolioHeadingTag className='portfolio-proposal-main-heading'>
        <button
          type='button'
          className='portfolio-proposal-accordion-toggle'
          ref={this.targetRef}
          aria-expanded={isPortfolioTitleDescriptionOpen}
          data-testid='portfolio-title-description-toggle'
          onClick={() => this.setState({
            isPortfolioTitleDescriptionOpen: !isPortfolioTitleDescriptionOpen,
          })}
        >
          <span className='portfolio-proposal-title'>{this.getPortfolioProposalTitle()}</span>
          <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
        </button>
      </PortfolioHeadingTag>
    );

    return (

      <div className='body'>
        {loading && <div style={spinStyle}>
          <Spin spinning={loading} size="large" tip={tipMessage} />
        </div>}
        <div style={{ pointerEvents: loading ? 'none' : 'auto', width: '95%' }}>
          {headerTitleElement && ReactDOM.createPortal(
            <div style={{ pointerEvents: loading ? 'none' : 'auto' }}>
              {isValURL ? futureAssetSimulationTitleToggle : portfolioTitleToggle}
            </div>,
            headerTitleElement
          )}
          {isValURL && <div style={{ display: 'flex', flexDirection: 'column' }}>
            {(!headerTitleElement || isFutureAssetSimulationDescriptionOpen) && <div className='portfolio-proposal-heading future-asset-simulation-heading'>
              {!headerTitleElement && futureAssetSimulationTitleToggle}
              {isFutureAssetSimulationDescriptionOpen && (
                <div
                  className='portfolio-proposal-accordion-content'
                  data-testid='future-asset-simulation-description-content'
                >
                  {this.translateMessage('FutureAssetSimulationHelp')}
                </div>
              )}
            </div>}


            {/* 初期投資額 */}
            <div style={{ width: '100%', display: 'flex', marginLeft: '20px', paddingRight: '20px', justifyContent: 'flex-start' }}>
              <div style={{ flex: 6, fontSize: '15px', color: '#a6a6a6', textAlign: 'left' }}><FormattedMessage id='InitialInvestment' /></div>
              <div style={{ flex: 6, textAlign: 'left' }}>
                <InputNumber
                  className="rightAlignNumber"   // 20260107 UEDA 追加
                  style={{ fontSize: '16px', color: 'black' }}
                  min={0}
                  inputMode="decimal"
                  //formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  onChange={this.onChangeInitAmount}
                  value={initAmount}
                />
                <span> <FormattedMessage id='Million' /></span>
              </div>
              <div style={{ flex: 2 }}></div>
            </div>


            {/* 積立月額 */}
            <div style={{ width: '100%', display: 'flex', marginTop: '5px', marginLeft: '20px', paddingRight: '20px', justifyContent: 'flex-start' }}>
              <div style={{ flex: 6, fontSize: '15px', color: '#a6a6a6', textAlign: 'left' }}><FormattedMessage id='MonthlySavingAmount' /></div>
              <div style={{ flex: 6, textAlign: 'left' }}>
                <InputNumber
                  className="rightAlignNumber"   // 20260107 UEDA 追加
                  style={{ fontSize: '16px', color: 'black' }}
                  min={0}
                  inputMode="decimal"
                  //formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  onChange={this.onChangeMonthlyAmount}
                  value={monthlyAmount}
                />
                <span> <FormattedMessage id='Million' /></span>
              </div>
              <div style={{ flex: 2 }}></div>
            </div>

            {/* 積立期間 */}
            <div style={{ width: '100%', display: 'flex', marginTop: '5px', marginLeft: '20px', paddingRight: '20px', justifyContent: 'flex-start' }}>
              <div style={{ flex: 6, fontSize: '15px', marginTop: '-3px', color: '#a6a6a6', textAlign: 'left', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div><span><FormattedMessage id='AccumulationPeriod' /></span></div>
                {this.renderValSettingHelpIcon('accumulationPeriod')}
              </div>
              <div style={{ flex: 8, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                <InputNumber
                  disabled={investYearDisabled}
                  className="rightAlignNumber"   // 20260107 UEDA 追加
                  style={{ fontSize: '16px', color: 'black' }}
                  min={0}
                  max={100}
                  inputMode="decimal"
                  onChange={this.onChangeInputTerm}
                  value={investYear}
                />
                <div style={{ width: '20px', marginLeft: '2px' }}><FormattedMessage id='Years' /></div>
                <Switch //自動に変更した場合は再計算した値を表示
                  style={{ marginLeft: '2px' }}
                  checkedChildren={this.translateMessage('Manual')}
                  unCheckedChildren={this.translateMessage('Auto')}
                  checked={!investYearDisabled}
                  onChange={(checkedManual) => {
                    // checkedManual === true  → 手入力
                    // checkedManual === false → 自動
                    const nextDisabled = !checkedManual;

                    if (nextDisabled) {
                      // 自動ON：現在の画面値から積立期間を再計算
                      const { volRate, displayMinVol, displayMaxVol } = this.state;
                      const autoYear = this.clacRiskInvestYear(volRate, displayMinVol, displayMaxVol);

                      this.setState({
                        investYearDisabled: true,
                        investYear: autoYear,
                        isCalcButtonDisabled: false,
                        specifyFlg: true,
                      });
                    } else {
                      // 手入力ON：値はそのまま
                      this.setState({
                        investYearDisabled: false,
                        isCalcButtonDisabled: false,
                        specifyFlg: true,
                      });
                    }
                  }}
                />
              </div>
            </div>
            {this.renderValSettingHelpContent('accumulationPeriod', this.translateMessage('RiskHelp'))}



            {/* 20260103 UEDA 積立後時価額（積立期間の直後に追加） */}
            <div style={{ width: '100%', display: 'flex', marginTop: '5px', marginLeft: '20px', paddingRight: '20px', justifyContent: 'flex-start' }}>
              <div style={{ flex: 6, fontSize: '15px', marginTop: '-3px', color: '#a6a6a6', textAlign: 'left', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div><span><FormattedMessage id='ValueAfterAccumulation' /></span></div>
                {this.renderValSettingHelpIcon('valueAfterAccumulation')}
              </div>
              {/* 右：値（箱） */}
              <div style={{ flex: 8, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                <InputNumber
                  className="rightAlignNumber"   // 20260107 UEDA 追加
                  disabled={true}
                  inputMode="decimal"
                  style={{ fontSize: '16px', color: 'black' }}
                  value={valueBeforeTax}
                />
                <span> <FormattedMessage id='Million' /></span>
              </div>
            </div>
            {this.renderValSettingHelpContent('valueAfterAccumulation', this.translateMessage('ValueAfterAccumulationHelp'))}



            {/* 受取期間 */}
            <div style={{ width: '100%', display: 'flex', marginTop: '5px', marginLeft: '20px', paddingRight: '20px', justifyContent: 'flex-start' }}>
              <div style={{ flex: 6, fontSize: '15px', marginTop: '-3px', color: '#a6a6a6', textAlign: 'left', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div><span><FormattedMessage id='ReceveTerm' /></span></div>
                {this.renderValSettingHelpIcon('receiveTerm')}
              </div>
              <div style={{ flex: 8, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                <InputNumber
                  className="rightAlignNumber"   // 20260107 UEDA 追加
                  disabled={recPeriodDisabled}
                  style={{ fontSize: '16px', color: 'black' }}
                  min={1}
                  inputMode="decimal"
                  onChange={this.onChangeRecPeriod}
                  value={recPeriod} />
                <div style={{ width: '20px', marginLeft: '2px' }}><FormattedMessage id='Years' /></div>
                <Switch style={{ marginLeft: '2px' }} checkedChildren={this.translateMessage('Manual')} unCheckedChildren={this.translateMessage('Auto')} checked={!recPeriodDisabled} onChange={() => this.setState({ recPeriodDisabled: !recPeriodDisabled, isCalcButtonDisabled: false, recPeriod: recPeriodDisabled ? recPeriod : DEFAULT_RECEIVE_YEARS })} />
              </div>
            </div>
            {this.renderValSettingHelpContent('receiveTerm', this.translateMessage('ReceveTermHelp'))}



            {/* 受取月額 */}
            <div style={{ width: '100%', display: 'flex', marginTop: '5px', marginLeft: '20px', paddingRight: '20px', justifyContent: 'flex-start' }}>
              <div style={{ flex: 6, fontSize: '15px', marginTop: '-3px', color: '#a6a6a6', textAlign: 'left', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div><span><FormattedMessage id='ReceveMonthly' /></span></div>
                {this.renderValSettingHelpIcon('receiveMonthly')}
              </div>
              <div style={{ flex: 8, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                <InputNumber
                  className="rightAlignNumber"   // 20260107 UEDA 追加
                  disabled={true}
                  inputMode="decimal"
                  style={{ fontSize: '16px', color: 'black' }}
                  value={payMonthly}
                />
                <div style={{ width: '40px', marginLeft: '2px' }}><FormattedMessage id='Million' /></div>
              </div>
            </div>
            {this.renderValSettingHelpContent('receiveMonthly', this.translateMessage('ReceveMonthlyHelp'))}


            {/* 期待リターン */}
            <div style={{ width: '100%', display: 'flex', marginTop: '5px', marginLeft: '20px', paddingRight: '20px', justifyContent: 'flex-start' }}>
              <div style={{ flex: 6, fontSize: '15px', color: '#a6a6a6', textAlign: 'left', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div><span><a href='https://cloudoz.jp/%e5%b9%b4%e7%8e%87%e3%83%aa%e3%82%bf%e3%83%bc%e3%83%b3%e8%a8%88%e7%ae%97%e6%96%b9%e6%b3%95/' target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'underline' }}><FormattedMessage id='ExpectedReturn' values={{ br: <br /> }} /></a></span></div>
                {this.renderValSettingHelpIcon('expectedReturn')}
              </div>
              <div style={{ flex: 8, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                <InputNumber
                  className="rightAlignNumber"   // 20260107 UEDA 追加
                  disabled={investRetRateDisabled}
                  style={{ fontSize: '16px', color: 'black' }}
                  min={0}
                  inputMode="decimal"
                  //formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  onChange={this.onChangeInvestRetRate}
                  value={investRetRate}
                />
                <div style={{ width: '20px', marginLeft: '2px' }}>%</div>
                <Switch //自動に変更した場合は最適化計算結果の期待リターン値を表示する。
                  style={{ marginLeft: '2px' }}
                  checkedChildren={this.translateMessage('Manual')}
                  unCheckedChildren={this.translateMessage('Auto')}
                  checked={!investRetRateDisabled}
                  onChange={(checkedManual) => {
                    const nextDisabled = !checkedManual; // false=手入力, true=自動

                    if (nextDisabled) {
                      // 自動ON → 最適化結果を反映
                      this.setState({
                        investRetRateDisabled: true,
                        investRetRate: this.state.retRate,
                        isCalcButtonDisabled: false,
                      });
                    } else {
                      // 手入力ON
                      this.setState({
                        investRetRateDisabled: false,
                        isCalcButtonDisabled: false,
                      });
                    }
                  }}
                />
              </div>
            </div>
            {this.renderValSettingHelpContent('expectedReturn', this.translateMessage('ReturnHelp'))}



            {/* 期待リターン */}
            <div style={{ width: '100%', display: 'flex', marginTop: '5px', marginLeft: '20px', paddingRight: '20px', justifyContent: 'flex-start' }}>
              <div style={{ flex: 6, fontSize: '15px', color: '#a6a6a6', textAlign: 'left', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div><span><a href='https://cloudoz.jp/%e5%b9%b4%e7%8e%87%e3%83%aa%e3%82%bf%e3%83%bc%e3%83%b3%e8%a8%88%e7%ae%97%e6%96%b9%e6%b3%95/' target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'underline' }}><FormattedMessage id='ExpectedReturnRec' values={{ br: <br /> }} /></a></span></div>
                {this.renderValSettingHelpIcon('expectedReturnRec')}
              </div>
              <div style={{ flex: 8, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                <InputNumber
                  className="rightAlignNumber"   // 20260107 UEDA 追加
                  disabled={investRetRateRecDisabled}
                  style={{ fontSize: '16px', color: 'black' }}
                  min={0}
                  inputMode="decimal"
                  //formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  onChange={this.onChangeInvestRetRateRec}
                  value={investRetRateRec}
                />
                <div style={{ width: '20px', marginLeft: '2px' }}>%</div>
                <Switch style={{ marginLeft: '2px' }} checkedChildren={this.translateMessage('Manual')} unCheckedChildren={this.translateMessage('Auto')} checked={!investRetRateRecDisabled} onChange={() => this.setState({ investRetRateRec: (!investRetRateRecDisabled ? 3.0 : investRetRateRec), investRetRateRecDisabled: !investRetRateRecDisabled, isCalcButtonDisabled: false })} />
              </div>
            </div>
            {this.renderValSettingHelpContent('expectedReturnRec', this.translateMessage('ReturnHelpRec'))}


            {/* 想定リスク */}
            <div style={{ width: '100%', display: 'flex', marginTop: '5px', marginLeft: '20px', paddingRight: '20px', justifyContent: 'flex-start' }}>
              <div style={{ flex: 6, fontSize: '15px', color: '#a6a6a6', textAlign: 'left', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                <div><span><a href='https://cloudoz.jp/%e5%b9%b4%e7%8e%87%e3%83%aa%e3%82%b9%e3%82%af%e3%81%ae%e8%a8%88%e7%ae%97%e6%96%b9%e6%b3%95/' target='_blank' rel='noopener noreferrer' style={{ textDecoration: 'underline' }}><FormattedMessage id='ExpectedRisk' /></a></span></div>
                {this.renderValSettingHelpIcon('expectedRisk')}
              </div>
              <div style={{ flex: 8, textAlign: 'left', display: 'flex', alignItems: 'center' }}>
                <InputNumber
                  className="rightAlignNumber"   // 20260107 UEDA 追加
                  disabled={investVolRateDisabled}
                  style={{
                    fontSize: '16px', color: 'black',
                    appearance: 'none',
                    lineHeight: 'normal',
                    WebkitAppearance: 'none'
                  }}
                  min={0}
                  inputMode="decimal"
                  //formatter={(value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                  onChange={this.onChangeInvestVolRate}
                  value={investVolRate}
                />
                <div style={{ width: '20px', marginLeft: '2px' }}>%</div>
                <Switch //20251227 UEDA 自動に変更した場合は最適化計算結果のリスク値を表示する。
                  style={{ marginLeft: '2px' }}
                  checkedChildren={this.translateMessage('Manual')}
                  unCheckedChildren={this.translateMessage('Auto')}
                  checked={!investVolRateDisabled}
                  onChange={(checkedManual) => {
                    const nextDisabled = !checkedManual; // false=手入力, true=自動

                    if (nextDisabled) {
                      // 自動ON → 最適化結果の想定リスクを反映
                      this.setState({
                        investVolRateDisabled: true,
                        investVolRate: this.state.volRate, // ← ★最適化結果
                        isCalcButtonDisabled: false,
                      });
                    } else {
                      // 手入力ON
                      this.setState({
                        investVolRateDisabled: false,
                        isCalcButtonDisabled: false,
                      });
                    }
                  }}
                />                            </div>
            </div>
            {this.renderValSettingHelpContent('expectedRisk', this.translateMessage('RiskHelp1'))}


            {/* 再計算ボタン */}
            <div style={{ height: '40px', marginTop: '20px', marginLeft: '20px' }} >
              <ClickButton style={{ width: '100%', height: '32px' }} onClick={() => this.handleClickCalcRatio()} disabled={isCalcButtonDisabled}><PieChartOutlined /> <FormattedMessage id='Recalculation' /></ClickButton>
            </div>


            {/* ※XX年後の累積積立額は～ */}
            {futureSimulationImage && <div style={{ fontSize: '15px', fontWeight: 'bolder', textAlign: "left", marginLeft: '20px', lineHeight: '1', wordWrap: 'break-word' }}>
              <span >{simulationMsg[0]}
                {this.renderValSettingHelpIcon('taxHelp')}
              </span>
              <span>{simulationMsg[1]}
                {this.renderValSettingHelpIcon('taxHelp1')}
              </span >
              <span>{simulationMsg[2]}</span>
              {this.renderValSettingHelpContent('taxHelp', this.translateMessage('TaxHelp'))}
              {this.renderValSettingHelpContent('taxHelp1', this.translateMessage('TaxHelp1'))}
            </div>}


            {/* 積立後時価額チャート */}
            {futureSimulationImage && <div style={{ fontSize: '15px', color: '#a6a6a6', textAlign: "left", marginLeft: '20px', marginTop: '20px' }}><span><FormattedMessage id='AssetForecastChart' /></span></div>}
            {futureSimulationImage && <img src={futureSimulationImage} style={{ width: '100%', height: 'auto', paddingLeft: '10px', paddingBottom: '20px' }} alt=''></img>}
            <div className='divider'></div>
          </div>}
          <List>
            {(isValURL || !headerTitleElement || isPortfolioTitleDescriptionOpen) && <div className='portfolio-proposal-heading'>
              {(isValURL || !headerTitleElement) && portfolioTitleToggle}
              {isPortfolioTitleDescriptionOpen && (
                <div
                  className='portfolio-proposal-accordion-content'
                  data-testid='portfolio-title-description-content'
                >
                  {this.translateMessage('PortfolioTitleHelp')}
                </div>
              )}
            </div>}
            <div className='portfolio-summary proposal-card-row'>
              <div className='portfolio-section'>
                <button
                  type='button'
                  className='portfolio-section-accordion-toggle'
                  aria-expanded={isInvestmentStyleDescriptionOpen}
                  data-testid='investment-style-description-toggle'
                  onClick={() => this.setState({
                    isInvestmentStyleDescriptionOpen: !isInvestmentStyleDescriptionOpen,
                  })}
                >
                  <span>{this.getInvestmentStyleAccordionLabel()}</span>
                  <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
                </button>
                {isInvestmentStyleDescriptionOpen && (
                  <div
                    className='portfolio-section-accordion-content'
                    data-testid='investment-style-description-content'
                  >
                    {this.getInvestmentStyleTooltipContent()}
                  </div>
                )}
                <div className='investment-style-segmented' role='tablist' aria-label={this.getLocalizedText('投資スタイルの選択', 'Select investment style')}>
                  {this.getInvestmentStyleThresholds().map((style) => {
                    const isSelected = selectedInvestmentStyle?.key === style.key;
                    const isEnabled = this.isInvestmentStyleEnabled(style.key);
                    return (
                      <button
                        key={style.key}
                        type='button'
                        className={`investment-style-segment ${isSelected ? 'selected' : ''}`}
                        aria-pressed={isSelected}
                        aria-disabled={!isEnabled}
                        disabled={!isEnabled}
                        onClick={() => this.handleInvestmentStyleSelect(style.key)}
                      >
                        {this.getLocalizedText(style.labelJa, style.labelEn)}
                      </button>
                    );
                  })}
                </div>
              </div>
            </div>
            <List.Item
              className='item3'
              style={{ display: 'none' }}
            >
              <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'center', width: '100%', marginRight: '-20px', marginTop: '20px' }}>
                <div style={{ width: '100%', display: 'flex' }}>
                  <img
                    src={blankImage}
                    alt="期待リターン:12.28%"
                    style={{
                      position: "absolute",
                      width: "1px",
                      height: "1px",
                      padding: 0,
                      margin: "-1px",
                      overflow: "hidden",
                      clip: "rect(0,0,0,0)",
                      whiteSpace: "nowrap",
                      border: 0
                    }}
                  />
                  <div style={{ fontSize: '15px', color: '#a6a6a6' }}><FormattedMessage id='ExpectedReturn' values={{ br: <br /> }} /></div>
                  <div style={{ fontSize: '15px', fontWeight: 'bolder', marginRight: '20px' }}>{retRate}%</div>
                </div>
                {/* <div style={{display:'flex',flexDirection:'row',justifyContent:'flex-end',alignItems:'center',width:'40px'}}>
                              <div  style={{border:'1px solid darkgrey',height:'20px'}}></div>
                              <Button type="link" onClick={()=>this.setState({settingVisible1:true})} icon={<SettingOutlined style={{ fontSize: '100%'}}/>}></Button>
                            </div> */}
              </div>
            </List.Item>
            <List.Item className='accumulation-period-item'>
              <div className='portfolio-summary proposal-card-row'>
                <div className='portfolio-section accumulation-period-section'>
                  <button
                    type='button'
                    className='portfolio-section-accordion-toggle'
                    aria-expanded={isAccumulationPeriodDescriptionOpen}
                    data-testid='accumulation-period-description-toggle'
                    onClick={() => this.setState({
                      isAccumulationPeriodDescriptionOpen: !isAccumulationPeriodDescriptionOpen,
                    })}
                  >
                    <span>{this.getAccumulationPeriodAccordionLabel()}</span>
                    <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
                  </button>
                  {isAccumulationPeriodDescriptionOpen && (
                    <div
                      className='portfolio-section-accordion-content'
                      data-testid='accumulation-period-description-content'
                    >
                      {this.translateMessage('Riskhelp2')}
                    </div>
                  )}
                  <div className='accumulation-period-compact'>
                    <div className='accumulation-period-primary-value'>{this.formatYearsValue(riskInvestYear)}</div>
                    <div className='accumulation-period-risk'>
                      {this.formatMessageWithFallback('ExpectedRisk', '想定リスク', 'Expected risk')}：
                      <span className='accumulation-period-risk-value'>{this.formatPercentValue(volRate)}</span>
                    </div>
                  </div>
                  <div className='accumulation-period-slider'>
                    <img
                      src={blankImage}
                      alt="積立期間:リスク最小は0年、リスク最大は30年以上として期間をリスクに均等割り当て Replace the stocks in the portfolio and run the optimization calculation"
                      style={{
                        position: "absolute",
                        width: "1px",
                        height: "1px",
                        padding: 0,
                        margin: "-1px",
                        overflow: "hidden",
                        clip: "rect(0,0,0,0)",
                        whiteSpace: "nowrap",
                        border: 0
                      }}
                    />
                    <Slider
                      className='accumulation-period-slider-control'
                      style={{ width: '100%', margin: '0', ...accumulationSliderRailCssVars }}
                      step={0.5}
                      max={displayMaxVol}
                      min={this.getRiskSliderMinValue()}
                      marks={accumulationSliderMarks}
                      value={accumulationSliderValue}
                      included={false}
                      railStyle={accumulationSliderRailStyle}
                      trackStyle={{ backgroundColor: 'transparent' }}
                      tipFormatter={this.getRiskSliderTooltipText}
                      handleStyle={handleStyle}
                      onChange={this.onChangeRisk}
                      onAfterChange={this.onAfterChangeRisk}
                    />
                  </div>
                  <div className='accumulation-period-actions'>
                    {optimalBtnDisabled ? (
                      <div className='optimal-state-badge' aria-live='polite'>
                        <CheckCircleFilled />
                        <span>{this.getLocalizedText('現在は最適状態です', 'Currently optimized')}</span>
                      </div>
                    ) : (
                      <div className='accumulation-period-action-group'>
                        <ClickButton style={{ fontSize: '13px' }} onClick={this.handleOptimalVolClick}>
                          {this.getLocalizedText('最適状態に戻す', 'Restore optimal state')}
                        </ClickButton>
                        {this.renderValSettingHelpIcon('maximizesSharpeRatio')}
                      </div>
                    )}
                    {this.renderValSettingHelpContent('maximizesSharpeRatio', this.translateMessage('MaximizesSharpeRatioHelp'))}
                  </div>
                </div>
              </div>
            </List.Item>
            <List.Item className='recommended-allocation-item'>
              <div className='recommended-allocation-content'>
                <div className='recommended-allocation-header'>
                  <div className='recommended-allocation-title-wrap'>
                    <button
                      type='button'
                      className='portfolio-section-accordion-toggle'
                      aria-expanded={isRecommendedAllocationDescriptionOpen}
                      data-testid='recommended-allocation-description-toggle'
                      onClick={() => this.setState({
                        isRecommendedAllocationDescriptionOpen: !isRecommendedAllocationDescriptionOpen,
                      })}
                    >
                      <span>{this.getRecommendedAllocationTitle()}</span>
                      <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
                    </button>
                    <img
                      src={blankImage}
                      alt="最適化計算の結果得られた銘柄の保有割合を、円グラフで表示 Display the portfolio weights obtained from the optimization results in a pie chart."
                      style={{
                        position: "absolute",
                        width: "1px",
                        height: "1px",
                        padding: 0,
                        margin: "-1px",
                        overflow: "hidden",
                        clip: "rect(0,0,0,0)",
                        whiteSpace: "nowrap",
                        border: 0
                      }}
                    />
                    {isRecommendedAllocationDescriptionOpen && (
                      <div
                        className='portfolio-section-accordion-content'
                        data-testid='recommended-allocation-description-content'
                      >
                        {this.translateMessage('DisplayPieChart')}
                      </div>
                    )}
                  </div>
                  <ClickButton
                    style={{ height: '32px', whiteSpace: 'nowrap' }}
                    onClick={this.handleRatioSettingOn}
                  >
                    {this.getLocalizedText('配分条件', 'Allocation conditions')}
                  </ClickButton>
                </div>
                <div className='recommended-allocation-chart'>
                  <div className='optimal-pie-container' style={{ flex: 1 }} >
                    <OptimalPie ref={(ref) => (this.pie = ref)} optimalData={optimalPieData} /></div>
                </div>
              </div>
            </List.Item>
          </List>

          <div className='allocation-list-title-wrap'>
            <button
              type='button'
              className='portfolio-section-accordion-toggle'
              aria-expanded={isAllocationListDescriptionOpen}
              data-testid='allocation-list-description-toggle'
              onClick={() => this.setState({
                isAllocationListDescriptionOpen: !isAllocationListDescriptionOpen,
              })}
            >
              <span>{this.getLocalizedText('配分一覧', 'Allocation list')}</span>
              <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
            </button>
            {isAllocationListDescriptionOpen && (
              <div
                className='portfolio-section-accordion-content allocation-list-description-content'
                data-testid='allocation-list-description-content'
              >
                <div>
                  {this.getLocalizedText(
                    '配分一覧では、最適化されたポートフォリオに含まれる各資産区分について、想定リスク、想定リターン、配分割合を一覧で確認できます。',
                    'The allocation list shows each asset class in the optimized portfolio along with its expected risk, expected return, and allocation ratio.'
                  )}
                </div>
                <div style={{ marginTop: '8px' }}>
                  <a
                    href="https://cloudoz.jp/%e9%8a%98%e6%9f%84%e9%81%b8%e6%8a%9e/"
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{ textDecoration: 'underline' }}
                  >
                    {this.translateMessage('StockSelectHelp1')}
                  </a>{' '}
                  {this.translateMessage('StockSelectHelp2')}
                </div>
              </div>
            )}
          </div>

          <List>
            <List
              size='small'
              className='item'
              onDragOver={(event) => event.preventDefault()}
              header={
                <div style={{ display: 'flex', width: '100%', textAlign: 'center' }}>
                  <div style={{ flex: 16, display: 'flex', justifyContent: 'start' }}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      {(sortName === 'type' && sortType === 'ASC') && <CaretUpOutlined style={{ fontSize: '14px', color: '#f30808' }} />}
                      {(sortName === 'type' && sortType === 'DESC') && <CaretDownOutlined style={{ fontSize: '14px', color: '#f30808' }} />}
                    </div>
                    <div style={{ textAlign: 'right' }} onClick={() => this.handleSortClick('type')}><FormattedMessage id='AssetClass' /></div>
                      <img
                        src={blankImage}
                        alt="資産区分:銘柄選択はここを参照。 カッコ内は資産区分代表とする銘柄コード"
                        style={{
                          position: "absolute",
                          width: "1px",
                          height: "1px",
                          padding: 0,
                          margin: "-1px",
                          overflow: "hidden",
                          clip: "rect(0,0,0,0)",
                          whiteSpace: "nowrap",
                          border: 0
                        }}
                      />
                  </div>
                  <div style={{ flex: 7, display: 'flex', justifyContent: 'end' }} onClick={() => this.handleSortClick('riskRatio')}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      {(sortName === 'riskRatio' && sortType === 'ASC') && <CaretUpOutlined style={{ fontSize: '14px', color: '#f30808' }} />}
                      {(sortName === 'riskRatio' && sortType === 'DESC') && <CaretDownOutlined style={{ fontSize: '14px', color: '#f30808' }} />}
                    </div>
                    <span style={{ textAlign: 'left' }} ><FormattedMessage id='Risk' /></span>
                  </div>
                  <div style={{ flex: 7, display: 'flex', justifyContent: 'end' }} onClick={() => this.handleSortClick('returnRatio')}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      {(sortName === 'returnRatio' && sortType === 'ASC') && <CaretUpOutlined style={{ fontSize: '14px', color: '#f30808' }} />}
                      {(sortName === 'returnRatio' && sortType === 'DESC') && <CaretDownOutlined style={{ fontSize: '14px', color: '#f30808' }} />}
                    </div>
                    <span style={{ textAlign: 'left' }} ><FormattedMessage id='Return' /></span>
                  </div>
                  <div style={{ flex: 7, display: 'flex', justifyContent: 'end' }} onClick={() => this.handleSortClick('optimalRatio')}>
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                      {(sortName === 'optimalRatio' && sortType === 'ASC') && <CaretUpOutlined style={{ fontSize: '14px', color: '#f30808' }} />}
                      {(sortName === 'optimalRatio' && sortType === 'DESC') && <CaretDownOutlined style={{ fontSize: '14px', color: '#f30808' }} />}
                    </div>
                    <span style={{ textAlign: 'left' }} ><FormattedMessage id='Ratio' /></span>
                  </div>
                </div>
              }
              footer={
                <div style={{ display: 'flex', width: '100%', textAlign: 'center', fontSize: '14px', fontWeight: 'bold' }}>
                  <div style={{ flex: 4 }}></div>
                  <div style={{ flex: 13, display: 'flex', justifyContent: 'start' }} >
                    <div style={{ textAlign: 'right', color: '#a6a6a6' }} ><FormattedMessage id='Total' /></div>
                  </div>
                  <div style={{ flex: 7, display: 'flex', justifyContent: 'end' }} >
                    <div style={{ textAlign: 'left' }} >{this.formatPercentValue(volRate)}</div>
                  </div>
                  <div style={{ flex: 7, display: 'flex', justifyContent: 'end' }}>
                    <div style={{ textAlign: 'left' }} >{this.formatPercentValue(retRate)}</div>
                  </div>
                  <div style={{ flex: 7, display: 'flex', justifyContent: 'end' }}>
                    <div style={{ textAlign: 'left', color: 'black', fontWeight: 'normal' }} >100%</div>
                  </div>
                </div>
              }

              //最適割合一覧表の資産クラス
              dataSource={visibleOptimalList}
              renderItem={(item) => {
                const displayAssetLabel = item.displayType || this.getDisplayAssetLabel(item, optimalList);
                const assetTooltip = (
                  <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                    <div>{item.displayType || this.getAssetLabel(item)}</div>
                    <div style={{ color: '#6b7785' }}>{item.fullName}</div>
                  </div>
                );
                return (
                  <List.Item className={item.selected ? 'custom-list-item-select' : 'custom-list-item'}
                    draggable
                    onDragStart={() => this.handleDragStart(item.originalIndex)}
                    onDragOver={() => this.handleDragOver(item.originalIndex)}
                    onDragEnd={this.handleDragEnd}
                    style={{ cursor: isDragging ? 'grab' : 'grab' }}
                  >
                    <div style={{ display: 'flex', width: '100%' }}>
                      <div style={{ flex: 1, color: this.getItemColor(item) }}>■</div>
                      <div style={{ flex: 16, textAlign: 'left', color: '#a6a6a6', }} onClick={() => this.handleSecClick(item.code)}>
                        <Tooltip title={assetTooltip} placement="topLeft">
                          <span style={{ color: 'black', }}> {displayAssetLabel}</span>
                        </Tooltip>
                        (<a href={makeURL(item)} target='_blank' rel='noopener noreferrer'
                          style={{ textDecoration: 'underline' }}
                        >{removeTFromCode(item.code)}</a>)
                      </div>
                      <div style={{ flex: 7, textAlign: 'right', color: 'black' }} onClick={() => this.handleSecClick(item.code)}>{rateFormat1(item.riskRatio)}%</div>
                      <div style={{ flex: 7, textAlign: 'right', color: 'black' }} onClick={() => this.handleSecClick(item.code)}>{rateFormat1(item.returnRatio)}%</div>
                      <div style={{ flex: 7, textAlign: 'right', fontWeight: (item.optimalRatio !== 0) ? 'bolder' : 'normal' }}
                        onClick={() => this.handleSecClick(item.code)}>
                        {rateFormat1(item.optimalRatio)}%</div>
                    </div>
                  </List.Item>
                )
              }}
            />
          </List>
          {showDetailToggle && (
            <div className='detail-toggle-row'>
              <a
                href="#detail-allocation-toggle"
                className='detail-toggle-link'
                onClick={(event) => {
                  event.preventDefault();
                  this.setState({ showDetailedAllocations: !showDetailedAllocations });
                }}
              >
                {showDetailedAllocations ? <CaretUpOutlined /> : <CaretDownOutlined />}
                {this.getDetailToggleLabel(showDetailedAllocations)}
              </a>
            </div>
          )}

          <div
            className='divider'
            style={{
              marginTop: '24px',
              marginBottom: '16px',
              borderTop: '1px solid #eeeeee'
            }}
          ></div>

          <div
            style={{
              fontSize: '15px',
              color: '#a6a6a6',
              marginTop: '8px',
            }}
          >
            <div
              style={{
                textAlign: 'right',
                whiteSpace: 'nowrap',
                marginRight: '4px',
                fontSize: '14px',
              }}
            >
              データ基準日：{DateTimeToString(actualEndDate)}
            </div>
            <div style={{ textAlign: 'center', marginTop: '8px' }}>
              <FormattedMessage id='CalcTitle' />
            </div>
          </div>
          <List>
            <div style={{ marginLeft: '20px', marginTop: '25px' }}>
              <div className='asset-change-actions-wrapper'>
                <img
                  src={blankImage}
                  alt="日本株17銘柄を設定して最適化計算を実行、またはポートフォリオの銘柄を入替えて最適化計算を実行"
                  style={{
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    padding: 0,
                    margin: "-1px",
                    overflow: "hidden",
                    clip: "rect(0,0,0,0)",
                    whiteSpace: "nowrap",
                    border: 0
                  }}
                />
                <div className='asset-change-actions'>
                  <ClickButton
                    className='asset-change-button asset-change-button-toggle'
                    style={{
                      height: '32px',
                      borderRadius: '3px',
                      fontSize: '15px',
                      whiteSpace: 'nowrap'
                    }}
                    onClick={this.handleToggleJapaneseStocks}
                    disabled={addAssetDisabled}
                  >
                    <SwapOutlined /> {this.getJapaneseStocksToggleLabel(isJapaneseStocksMode)}
                  </ClickButton>
                    <ClickButton
                      className='asset-change-button asset-change-button-primary'
                      style={{
                        height: '32px',
                        borderRadius: '3px',
                        flex: '1 1 auto'
                      }}
                      onClick={() => this.handleAddAsset()}
                      disabled={addAssetDisabled}
                    >
                    <SwapOutlined /> <FormattedMessage id='SecChangeButton' />
                  </ClickButton>
                  <ClickButton
                    className='asset-change-button asset-change-button-secondary'
                    style={{
                      height: '32px',
                      borderRadius: '3px',
                      whiteSpace: 'nowrap'
                    }}
                    onClick={this.handleOtherSettingOn}
                  >
                    {this.getLocalizedText('その他の設定', 'Other settings')}
                  </ClickButton>
                </div>
              </div>
            </div>

            {ShowObservationPeriod &&
              <List.Item className='item3'>
                <div style={{ width: '100%', display: 'flex', marginRight: '-20px', marginTop: '20px', alignItems: 'center' }}>
                  <img
                    src={blankImage}
                    alt="観測期間：最適化の前提となる過去価格を選択するため、開始日と終了日を指定 Specify the start and end dates to select the historical prices used for the optimization."
                    style={{
                      position: "absolute",
                      width: "1px",
                      height: "1px",
                      padding: 0,
                      margin: "-1px",
                      overflow: "hidden",
                      clip: "rect(0,0,0,0)",
                      whiteSpace: "nowrap",
                      border: 0
                    }}
                  />
                  <div style={{ fontSize: '15px', color: '#a6a6a6', display: 'flex', alignItems: 'center' }}><span><FormattedMessage id='ObservationPeriod' /></span>
                    {this.renderValSettingHelpIcon('historicalStartEnd')}
                  </div>
                  <div><span>：</span></div>
                  <div style={{ fontSize: '15px', fontWeight: 'bolder' }}>{DateTimeToString(startDate)} ～ {DateTimeToString(actualEndDate)}</div>
                </div>
                {this.renderValSettingHelpContent('historicalStartEnd', this.translateMessage('HistoricalStartEndHelper'))}

                <Slider style={{ width: '85%', marginLeft: '25px' }}
                  range step={1}
                  max={periodMonths} min={0} marks={periodMarks}
                  value={periodValue}
                  railStyle={railStyle1}
                  trackStyle={[trackStyle]}
                  tipFormatter={this.ontipFormat}
                  handleStyle={[handleStyle, handleStyle]}
                  onChange={this.onChangePeriod}
                  onAfterChange={this.onAfterChangePeriod} />
              </List.Item>}
          </List>


          {/* 区切り線 */}
          <div
            className='divider'
            style={{
              marginTop: '30px',
              marginBottom: '10px'
            }}
          ></div>

          <div
            style={{
              fontSize: '14px',
              color: '#999',
              margin: '24px 20px 10px 20px',
              fontWeight: 'normal',
              textAlign: 'center'
            }}
          >
            以下は参考情報
          </div>

          <div style={{ display: 'flex', justifyContent: 'space-between', textAlign: 'center', marginTop: '20px' }}>
            <div className='allocation-list-title-wrap' style={{ margin: '5px 0px -10px 20px ' }}>
              <img
                src={blankImage}
                alt="価格グラフ:配当調整後の株価を開始日の株価で割り算した値。凡例のカッコ内は銘柄コード。"
                style={{
                  position: "absolute",
                  width: "1px",
                  height: "1px",
                  padding: 0,
                  margin: "-1px",
                  overflow: "hidden",
                  clip: "rect(0,0,0,0)",
                  whiteSpace: "nowrap",
                  border: 0
                }}
              />
              <button
                type='button'
                className='portfolio-section-accordion-toggle'
                aria-expanded={isPriceGraphDescriptionOpen}
                data-testid='price-graph-description-toggle'
                onClick={() => this.setState({
                  isPriceGraphDescriptionOpen: !isPriceGraphDescriptionOpen,
                })}
              >
                <span><FormattedMessage id='PriceGraph' /></span>
                <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
              </button>
              {isPriceGraphDescriptionOpen && (
                <div
                  className='portfolio-section-accordion-content allocation-list-description-content'
                  data-testid='price-graph-description-content'
                >
                  {this.translateMessage('PriceGraphHelp')}
                </div>
              )}
            </div>

            {/* <Radio.Group style={{fontSize:'14px',marginLeft:'auto',marginTop:'5px'}} onChange={this.onChangeDisplayCcy} value={displayCcy}>
                        <Radio  value={1}><FormattedMessage id='Yen' /></Radio>
                        <Radio  value={2}><FormattedMessage id='Dollar' /></Radio>
                      </Radio.Group> */}
            {/* <ClickButton style={{height:'28px'}} onClick={()=>this.handleClickPriceDownload()} ><DownloadOutlined/> </ClickButton> */}
          </div>
          <div style={{ width: '100%', display: 'flex', justifyContent: 'flex-start', flexWrap: 'wrap', alignItems: 'start', margin: '5px 0px 0px 20px ' }} >
            {optimalList.map((item, index) => {
              const title = item.type + '(' + removeTFromCode(item.code) + ')'
              const displayTitle = isJapaneseStocksMode
                ? (item.displayType || item.type)
                : (item.displayType || item.type) + '(' + removeTFromCode(item.code) + ')'
              return <Checkbox key={`${item.type}-${item.code}-${index}`} value={title} checked={config.checked.includes(title)} onChange={(event) => this.onChangeEnabled(title, event)}>
                <div style={{ display: 'flex', marginTop: '0px' }}>
                  <div style={{ color: item.color, marginTop: '2px' }}>■</div>
                  <div style={{ fontSize: '12px', marginTop: '4px' }}>{displayTitle}</div>
                </div>
              </Checkbox>
            })}

          </div>

          {(() => {
            const visibleData = config.data.filter(point =>
              config.checked.includes(point.z)
            );

            const visibleHeaders = config.header.filter(name =>
              config.checked.includes(name)
            );

            const visibleColors = visibleHeaders.map(name => {
              const index = config.header.indexOf(name);
              return config.color[index];
            });

            return <Line
              style={{ padding: '0px 10px 0px 10px', height: '350px' }}
              {...config}
              data={visibleData}
              color={visibleColors}
            />;
          })()}

          <div style={{ height: '40px' }} ></div>
          {ratioImage !== '' &&
            <div style={{ margin: '0px 0px 0px 20px' }}>
              <div className='allocation-list-title-wrap'>
                <img
                  src={blankImage}
                  alt="リスク・リターン分布図:投資対象のリスクとリターンの関係を視覚的に示すグラフです。効率的フロンティア（最も効率的な投資の組み合わせ）を視覚的に把握することができます。"
                  style={{
                    position: "absolute",
                    width: "1px",
                    height: "1px",
                    padding: 0,
                    margin: "-1px",
                    overflow: "hidden",
                    clip: "rect(0,0,0,0)",
                    whiteSpace: "nowrap",
                    border: 0
                  }}
                />
                <button
                  type='button'
                  className='portfolio-section-accordion-toggle'
                  aria-expanded={isRiskReturnDistributionDescriptionOpen}
                  data-testid='risk-return-distribution-description-toggle'
                  onClick={() => this.setState({
                    isRiskReturnDistributionDescriptionOpen: !isRiskReturnDistributionDescriptionOpen,
                  })}
                >
                  <span><FormattedMessage id='SharpeRatioDistributionChart' /></span>
                  <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
                </button>
                {isRiskReturnDistributionDescriptionOpen && (
                  <div
                    className='portfolio-section-accordion-content allocation-list-description-content'
                    data-testid='risk-return-distribution-description-content'
                  >
                    {this.translateMessage('SharpeRatioGraphHelp')}
                  </div>
                )}
              </div>
              {/* <img src='http://133.125.53.153/image/risk&return.png' style={{ width:'100%',height:'600px'}}></img> */}
              <FrontierChart src={ratioImage} hotspots={this.state.frontierChartHotspots} style={{ marginTop: '2px' }} alt='投資対象のリスクとリターンの関係を示すグラフ' />

            </div>
          }
          {correlationImage !== '' &&
            <div style={{ margin: '20px 0px 40px 20px' }}>
              <div className='allocation-list-title-wrap'>
                <button
                  type='button'
                  className='portfolio-section-accordion-toggle'
                  aria-expanded={isCorrelationMapDescriptionOpen}
                  data-testid='correlation-map-description-toggle'
                  onClick={() => this.setState({
                    isCorrelationMapDescriptionOpen: !isCorrelationMapDescriptionOpen,
                  })}
                >
                  <span><FormattedMessage id='CorrelationDistributionChart' /></span>
                  <QuestionCircleOutlined aria-hidden='true' style={{ color: '#1677ff', fontSize: 15, marginLeft: 5 }} />
                </button>
                {isCorrelationMapDescriptionOpen && (
                  <div
                    className='portfolio-section-accordion-content allocation-list-description-content'
                    data-testid='correlation-map-description-content'
                  >
                    {this.translateMessage('CorrelationGraphHelp')}
                  </div>
                )}
              </div>

              {/* <img src='http://133.125.53.153/image/risk&return.png' style={{ width:'100%',height:'600px'}}></img> */}
              <img src={correlationImage} style={{ width: '100%', height: 'auto', marginTop: '2px' }} alt='資産クラス間の相関を示すヒートマップです。相関係数（-1～+1）で動きの連動度を表し、色の濃淡で強弱を視覚化しています。相関が低い資産を組み合わせることで、ポートフォリオ全体のリスクを減らすことができます。逆に、相関が高い資産ばかりを組み合わせると、同時に下落するリスクが高まります。'></img>
              {this.renderCorrelationInsightSection({
                title: this.getLocalizedText('相関マップの見方', 'How to read the correlation map'),
                testId: 'correlation-insight',
              })}
              <div className='correlation-pair-panels'>
                {this.renderCorrelationPairSection({
                  title: this.getLocalizedText('相関が弱いペア（リスク低減・分散候補）', 'Weak-correlation pairs (risk reduction/diversification candidates)'),
                  stateKey: 'isWeakCorrelationPairsOpen',
                  pairs: weakCorrelationPairs,
                  emptyMessage: this.getLocalizedText('表示できる低相関ペアはありません。', 'No low-correlation pairs are available.'),
                  testId: 'weak-correlation-pairs',
                })}
                {this.renderCorrelationPairSection({
                  title: this.getLocalizedText('相関が強いペア（似た値動き）', 'Strong-correlation pairs (similar movement)'),
                  stateKey: 'isStrongCorrelationPairsOpen',
                  pairs: strongCorrelationPairs,
                  emptyMessage: this.getLocalizedText('表示できる高相関ペアはありません。', 'No high-correlation pairs are available.'),
                  testId: 'strong-correlation-pairs',
                })}
              </div>
            </div>
          }

          <div style={{ height: '40px', marginLeft: '20px', marginBottom: '40px' }} ><ClickButton style={{ width: '100%', height: '32px' }}
            onClick={() => this.handleClickPriceDownload()}><DownloadOutlined /> <FormattedMessage id='MarketDownloadButton' /></ClickButton></div>

        </div>
        <div className='divider'>
          <Drawer
            title={<div style={{ height: '50px' }}>
              <div style={{ display: 'flex' }}>
                <div style={{ fontSize: '18px', fontWeight: 'bold', marginRight: '20px' }}>{this.getLocalizedText('配分条件', 'Allocation conditions')}</div>
                <div style={{ flex: 1 }}></div>
                <ClickButton style={{ width: '100px' }} onClick={this.handleRatioSettingOff}>{ratioSelectTitle}</ClickButton>
              </div>
              <div style={{ color: 'red' }}>{errorMsg}</div>
            </div>}
            visible={settingVisible2}
            placement="right"
            closable={false}
            width={300}
            onClose={() => this.setState({ settingVisible2: false })}
          >
            <Row>
              {visibleRatioConstraintItems.map((item, index) => {
                return <Col key={item.code} span={24} style={{ height: '30px', paddingRight: '10px' }}>
                  <div style={{ display: 'flex' }}>
                    <span style={{ flex: 1, color: item.color }}>■</span>
                    <span style={{ flex: 11, fontSize: 13, width: '120px', maxWidth: '120px', color: '#a6a6a6', whiteSpace: 'nowrap' }}> <span style={{ color: 'black', }}>{item.type}</span>({removeTFromCode(item.code)})</span>
                    <Select value={normalizeConstraintOperator(item.express) || '='} onSelect={this.onChangeConditionExpress(item.code)} style={{ flex: 3 }} size="small" >
                      <Option value="<=">&lt;=</Option>
                      <Option value=">=">&gt;=</Option>
                      <Option value="=">=</Option>
                    </Select>
                    <InputNumber
                      style={{ flex: 3 }}
                      min={0}
                      max={100}
                      inputMode="decimal"
                      onChange={this.onChangeConditionExpressValue(item.code)}
                      onBlur={this.onBlurConditionExpressValue(item.code)}
                      value={item.expressValue} size="small" />
                    <span>%</span>
                  </div>
                </Col>
              })}
              <Col span={24} style={{ height: '30px' }}>
              </Col>
            </Row>
          </Drawer >
          <Drawer
            title={<div style={{ height: '50px' }}>
              <div style={{ display: 'flex' }}>
                <div style={{ fontSize: '18px', fontWeight: 'bold', marginRight: '20px' }}>{this.getLocalizedText('その他の設定', 'Other settings')}</div>
                <div style={{ flex: 1 }}></div>
                <ClickButton style={{ width: '100px' }} onClick={this.handleRatioSettingOff}>{ratioSelectTitle}</ClickButton>
              </div>
              <div style={{ color: 'red' }}>{errorMsg}</div>
            </div>}
            visible={settingVisible3}
            placement="right"
            closable={false}
            width={300}
            onClose={() => this.setState({ settingVisible3: false })}
          >
            <Row>
              <Col span={24} style={{ minHeight: '36px', height: 'auto', paddingRight: '10px', marginBottom: '8px' }}>
                <div style={{ display: 'flex' }}>
                  <span style={{ flex: '0 0 48px', minWidth: '48px', color: 'Black' }}></span>
                  <span style={{ flex: '0 0 120px', fontSize: 13, width: '120px', minWidth: '120px', maxWidth: '120px', color: '#a6a6a6', whiteSpace: 'nowrap' }}>
                    <span style={{ color: 'black', }}>{this.getLocalizedText('無リスク金利', 'Risk-free rate')}</span>
                    {this.renderValSettingHelpIcon('fixedDeposit10Year')}
                  </span>
                  {/* <Select value={'='} style={{flex: 3}} size="small" disabled >
                                            <Option value="=">=</Option>
                                          </Select>    */}
                  <InputNumber
                    className="risk-free-rate-input"
                    style={{ flex: '0 0 72px', maxWidth: '72px' }}
                    min={0}
                    max={100}
                    inputMode="decimal"
                    onChange={(value) => this.setState({ FixedDepositSetting: value, ratioSelectTitle: this.translateMessage('Apply') })}
                    value={FixedDepositSetting} size="small" />
                  <span>%</span>
                </div>
                {this.renderValSettingHelpContent('fixedDeposit10Year', this.translateMessage('FixedDeposit10YearHelp'))}
              </Col>
              <Col span={24} style={{ height: '42px', paddingRight: '10px', marginBottom: '8px' }}>
                <div style={{ display: 'flex' }}>
                  <span style={{ flex: '0 0 48px', minWidth: '48px', color: 'Black' }}></span>
                  <span style={{ flex: '0 0 120px', fontSize: 13, width: '120px', minWidth: '120px', maxWidth: '120px', color: '#a6a6a6', whiteSpace: 'nowrap' }}>
                    <span style={{ color: 'black', }}><FormattedMessage id='BaseCurrency' /></span>
                  </span>
                  <Select className="other-settings-select" size="small" style={{ flex: '0 0 88px', maxWidth: '88px' }}
                    onSelect={(v) => this.onChangeDefaultCcy(v)}
                    value={DefaultCcySetting} >
                    <Option value={'JPY'}><FormattedMessage id='JapanEn' /></Option>
                    <Option value={'USD'}><FormattedMessage id='USDollar' /></Option>
                  </Select>
                </div>
              </Col>

              <Col span={24} style={{ height: '42px', paddingRight: '10px', marginBottom: '8px' }}>
                <div style={{ display: 'flex' }}>
                  <span style={{ flex: '0 0 48px', minWidth: '48px', color: 'Black' }}></span>
                  <span style={{ flex: '0 0 120px', fontSize: 13, width: '120px', minWidth: '120px', maxWidth: '120px', color: '#a6a6a6', whiteSpace: 'nowrap' }}>
                    <span style={{ color: 'black', }}><FormattedMessage id='ShowObservationPeriod' /></span>
                  </span>
                  <Select className="other-settings-select" size="small" style={{ flex: '0 0 88px', maxWidth: '88px' }}
                    onSelect={(v) => this.onChangeShowObsPeriod(v)}
                    value={ShowObservationPeriodSetting} >
                    <Option value={true}><FormattedMessage id='yes' /> </Option>
                    <Option value={false}><FormattedMessage id='no' /> </Option>
                  </Select>
                </div>
              </Col>

              <Col span={24} style={{ height: '42px', paddingRight: '10px', marginBottom: '8px' }}>
                <div style={{ display: 'flex' }}>
                  <div style={{ flex: '0 0 48px', minWidth: '48px', color: 'Green', display: 'flex', alignItems: 'flex-start' }}></div>
                  <div style={{ flex: '0 0 120px', fontSize: 13, width: '120px', minWidth: '120px', maxWidth: '120px', color: '#a6a6a6', whiteSpace: 'nowrap', display: 'flex', alignItems: 'flex-start' }}>
                    <span style={{ color: 'black', }}><FormattedMessage id='ObservationPeriodStartDate' /></span>
                  </div>
                  {/* <DatePicker value={moment('2008-09-15','YYYY-MM-DD')} style={{flex: 6,}}
                                    allowClear={false}
                                    format='YYYY-MM-DD' 
                                    disabled
                                    // onChange={this.onChangeTradeDate}
                                    getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                    /> */}
                  <Select
                    className="other-settings-select"
                    size="small"
                    style={{ flex: '0 0 104px', maxWidth: '104px' }}
                    onSelect={this.onChangeObservValue}
                    value={newObservValue}
                  >
                    <Option value={1}><FormattedMessage id='Post-Lehman' /></Option>
                    <Option value={2}><FormattedMessage id='Oldest' /></Option>
                  </Select>
                </div>
              </Col>

              <Col span={24} style={{ height: '30px' }}>
              </Col>
            </Row>
          </Drawer >
          <Drawer
            title="1年後の金利変化によるシミュレーション（開発予定）"
            visible={settingVisible1}
            placement="right"
            onClose={() => this.setState({ settingVisible1: false })}
          >
            <Row>
              <Col span={24} >
                <div style={{ display: 'flex', flexDirection: 'column', height: '60px' }}>
                  <span style={{ fontSize: 16 }}>10年日本国債金利</span>
                  <div style={{ marginLeft: '30px' }}>
                    <Select defaultValue="plus" style={{ width: '35px' }} size="small">
                      <Option value="plus">＋</Option>
                      <Option value="mainis">－</Option>
                    </Select>
                    <InputNumber
                      min={0}
                      max={100}
                      inputMode="decimal"
                      defaultValue={0}
                      size="small" />
                  </div>
                </div>
              </Col>
              <Col span={24} >
                <div style={{ display: 'flex', flexDirection: 'column', height: '60px' }}>
                  <span style={{ fontSize: 16 }}>10年米国債金利</span>
                  <div style={{ marginLeft: '30px' }}>
                    <Select defaultValue="plus" style={{ width: '35px' }} size="small">
                      <Option value="plus">＋</Option>
                      <Option value="mainis">－</Option>
                    </Select>
                    <InputNumber
                      min={0}
                      max={100}
                      inputMode="decimal"
                      defaultValue={0}
                      size="small" />
                  </div>
                </div>

              </Col>
            </Row>
          </Drawer >
          <Drawer
            title={null}
            placement="left"
            closable={false}
            onClose={() => this.setState({ searchVisible: false })}
            visible={searchVisible}
            width={window.innerWidth}
            style={{ position: 'fixed', top: 0, left: 0 }}
          >
            <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
              <div >
                <div style={{ display: 'flex', margin: '10px 10px 5px 0px' }}>
                  <Input style={{ borderRadius: '10px', marginRight: '10px' }} size={'large'} value={searchValue} allowClear={true} placeholder={this.translateMessage('StockSearch')} onChange={this.handleSearchAsset} />
                  <ClickButton style={{ width: '120px', fontSize: 16 }} onClick={() => this.handleClickSearchFinish()}><FormattedMessage id={assetSelectTitle} /></ClickButton>
                </div>
                {errorMsg && (
                  <div style={{ color: 'red', marginBottom: '2px' }}>{errorMsg}</div>
                )}
              </div>
              <div style={{ flex: '1', overflowY: 'auto' }}>
                <div style={{
                  display: 'grid',
                  gridTemplateColumns: '92px 120px 80px',
                  columnGap: '8px',
                  marginLeft: '40px',
                  marginRight: '10px',
                  padding: '4px 0',
                  fontSize: 12,
                  color: 'rgba(0, 0, 0, 0.25)',
                  fontWeight: 'bold',
                }}>
                                    <button
                    type="button"
                    aria-label="資産区分を並べ替え"
                    onClick={() => this.handleAssetSearchSort('asset')}
                    style={{
                      display:'inline-flex',
                      alignItems:'center',
                      justifyContent:'flex-start',
                      gap:3,
                      padding:'4px 0',
                      border:0,
                      background:'transparent',
                      cursor:'pointer',
                      color:'#1677ff',
                      font:'inherit',
                      fontWeight:'inherit',
                      whiteSpace:'nowrap',
                    }}
                  >
                    <span>{this.getLocalizedText('資産区分', 'Asset class')}</span>
                    <span style={{
                      display:'inline-flex',
                      flexDirection:'column',
                      justifyContent:'center',
                      gap:2,
                      marginLeft:1,
                    }}>
                      {['asc', 'desc'].map((direction) => {
                        const active =
                          this.state.assetSearchSortField === 'asset' &&
                          this.state.assetSearchSortOrder === direction;
                        return (
                          <svg
                            key={direction}
                            width="12"
                            height="10"
                            viewBox="0 0 12 10"
                            aria-hidden="true"
                            style={{ display:'block', overflow:'visible' }}
                          >
                            <polygon
                              points={direction === 'asc'
                                ? '6,1 1,8 11,8'
                                : '1,2 11,2 6,9'}
                              fill={active ? '#1677ff' : '#ffffff'}
                              stroke={active ? '#1677ff' : '#8b9bad'}
                              strokeWidth="0.8"
                              strokeLinejoin="round"
                            />
                          </svg>
                        );
                      })}
                    </span>
                  </button>
                  <button
                    type="button"
                    aria-label="銘柄コードを並べ替え"
                    onClick={() => this.handleAssetSearchSort('code')}
                    style={{
                      display:'inline-flex',
                      alignItems:'center',
                      justifyContent:'flex-start',
                      gap:3,
                      padding:'4px 0',
                      border:0,
                      background:'transparent',
                      cursor:'pointer',
                      color:'#1677ff',
                      font:'inherit',
                      fontWeight:'inherit',
                      whiteSpace:'nowrap',
                    }}
                  >
                    <span>{this.getLocalizedText('銘柄コード', 'Code')}</span>
                    <span style={{
                      display:'inline-flex',
                      flexDirection:'column',
                      justifyContent:'center',
                      gap:2,
                      marginLeft:1,
                    }}>
                      {['asc', 'desc'].map((direction) => {
                        const active =
                          this.state.assetSearchSortField === 'code' &&
                          this.state.assetSearchSortOrder === direction;
                        return (
                          <svg
                            key={direction}
                            width="12"
                            height="10"
                            viewBox="0 0 12 10"
                            aria-hidden="true"
                            style={{ display:'block', overflow:'visible' }}
                          >
                            <polygon
                              points={direction === 'asc'
                                ? '6,1 1,8 11,8'
                                : '1,2 11,2 6,9'}
                              fill={active ? '#1677ff' : '#ffffff'}
                              stroke={active ? '#1677ff' : '#8b9bad'}
                              strokeWidth="0.8"
                              strokeLinejoin="round"
                            />
                          </svg>
                        );
                      })}
                    </span>
                  </button>
                  <button
                    type="button"
                    aria-label="開始を並べ替え"
                    onClick={() => this.handleAssetSearchSort('start')}
                    style={{
                      display:'inline-flex',
                      alignItems:'center',
                      justifyContent:'flex-start',
                      gap:3,
                      padding:'4px 0',
                      border:0,
                      background:'transparent',
                      cursor:'pointer',
                      color:'#1677ff',
                      font:'inherit',
                      fontWeight:'inherit',
                      whiteSpace:'nowrap',
                    }}
                  >
                    <span>{this.getLocalizedText('開始', 'Start')}</span>
                    <span style={{
                      display:'inline-flex',
                      flexDirection:'column',
                      justifyContent:'center',
                      gap:2,
                      marginLeft:1,
                    }}>
                      {['asc', 'desc'].map((direction) => {
                        const active =
                          this.state.assetSearchSortField === 'start' &&
                          this.state.assetSearchSortOrder === direction;
                        return (
                          <svg
                            key={direction}
                            width="12"
                            height="10"
                            viewBox="0 0 12 10"
                            aria-hidden="true"
                            style={{ display:'block', overflow:'visible' }}
                          >
                            <polygon
                              points={direction === 'asc'
                                ? '6,1 1,8 11,8'
                                : '1,2 11,2 6,9'}
                              fill={active ? '#1677ff' : '#ffffff'}
                              stroke={active ? '#1677ff' : '#8b9bad'}
                              strokeWidth="0.8"
                              strokeLinejoin="round"
                            />
                          </svg>
                        );
                      })}
                    </span>
                  </button>
                </div>
                <div style={{ backgroundColor: '#c8c8c8', height: '1px', marginTop: '2px' }}></div>

                  {(this.state.assetSearchSortOrder
                    ? [...searchResult].sort((a, b) => {
                        const field = this.state.assetSearchSortField;
                        const getValue = (item) => {
                          if (field === 'code') return String(item.Code ?? '');
                          if (field === 'start') {
                            return String(item.InceptionDate ?? '').slice(0, 10);
                          }
                          return String(item.Asset ?? '');
                        };
                        const comparison = getValue(a).localeCompare(
                          getValue(b), field === 'asset' ? 'ja' : 'en'
                        );
                        return this.state.assetSearchSortOrder === 'desc'
                          ? -comparison : comparison;
                      })
                    : searchResult
                  ).map((item, index) => {
                    return item.Visible && (
                      <div
                        key={item.Code}
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          marginRight: '10px'
                        }}
                      >
                          <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          margin: '5px 0px',
                          cursor: 'pointer'
                        }}
                        onClick={() =>
                          item.Select
                            ? this.handleClickSearchUnCheck(item)
                            : this.handleClickSearchCheck(item)
                        }
                      >
                      <div style={{ width: '30px' }}>
                        {!item.Select && (
                          <Button
                            type="link"
                            onClick={(e) => {
                              e.stopPropagation();   // ★ 行クリックを止める
                              this.handleClickSearchCheck(item);
                            }}
                            icon={<PlusCircleOutlined style={{ fontSize: '140%' }} />}
                          />
                        )}
                        {item.Select && (
                          <Button
                            type="link"
                            onClick={(e) => {
                              e.stopPropagation();   // ★ 行クリックを止める
                              this.handleClickSearchUnCheck(item);
                            }}
                            icon={<CheckCircleFilled style={{ fontSize: '140%' }} />}
                          />
                        )}
                      </div>

                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        fontSize: 12,
                        marginLeft: '10px',
                        flex: 1,
                        minWidth: 0,
                      }}>
                        <div style={{
                          display: 'grid',
                          gridTemplateColumns: '92px 120px 80px',
                          columnGap: '8px',
                          alignItems: 'start',
                        }}>
                          <div>
                            {this.getAssetLabel(item)}
                          </div>

                          <div style={{ whiteSpace: 'nowrap' }}>
                            <a
                              href={makeURL1(item)}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ textDecoration: 'underline', whiteSpace: 'nowrap' }}
                              onClick={(e) => e.stopPropagation()}   // ★ リンク押下でチェック切替しない
                            >
                              {removeTFromCode(item.Code)}
                            </a>
                          </div>

                          <div style={{ whiteSpace: 'nowrap' }}>
                            {String(item.InceptionDate ?? '').slice(0, 10)}
                          </div>
                        </div>

                        <div>
                          {item.Name}
                          {String(item.Memo ?? '').trim() && (
                            <span style={{ marginLeft: '5px' }}>※{String(item.Memo).trim()}</span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div style={{ backgroundColor: '#c8c8c8', height: '1px', marginTop: '2px' }}></div>
                  </div>
                  );
                })}
              </div>
            </div>






          </Drawer>
        </div>
      </div>
    )
  }
}


export default injectIntl(OptimalRatio); 
